export default
{   "key00":"모두",
    "key0": "홈",
    "key1": "market",
    "key2": "게임",
    "key3": "블로그",
    "key4": "게임 또는 상품 검색",
    "key5": "언어",
    "key6": "통화",
    "key7": "표시 통화는 표시 전용이며, 거래는 여전히 USD로 이루어집니다.",
    "key8": "확인",
    "key9": "인기 게임",
    "key10": "모든 게임",
    "key11": "로그인",
    "key12": "가입",
    "key13": "포인트 적립",
    "key14": "나",
    "key15": "메시지",
    "key16": "리뷰",
    "key17": "Sold",
    "key18": "로드 더",
    "key19": "Steam&스위치 CD키",
    "key20": "왜 우리를 선택해야 하나요?",
    "key21": "100% 안전한 거래",
    "key22": "우리는 효율적이고 전문적이며 안전한 거래 서비스를 제공하기 위해 최선을 다하고 있습니다. 플랫폼에서의 거래와 관련된 프로세스 및 관련 데이터 정보에 대한 보안을 100% 안전하게 보장할 것이니 안심하시기 바랍니다.",
    "key23": "24/7 지원",
    "key23_2": "전문 지원 팀이 여러분의 원활하고 즐거운 게임 여정을 위해 항상 준비되어 있습니다",
  "key23_3": "게임 충전",
  "key23_4": "게임 내 화폐와 가상 자산을 충전하여 쉽게 게임 경험을 업그레이드하세요",
  "key23_5": "현지 통화",
  "key23_6": "사용자는 선호하는 현지 통화로 구매할 수 있어 환전 번거로움이 사라집니다",
  "key23_7": "믿을 수 있는 스토어",
  "key23_8": "게임 자산 구매를 위한 안전하고 신뢰할 수 있는 플랫폼을 제공하는 것을 자랑스럽게 생각합니다",
    "key24": "강력한 고객 팀과 다양한 상담 방법을 통해 판매 전, 판매 중, 판매 후 필요한 지원을 포함하여 거래 프로세스 중 발생하는 모든 질문에 빠르고 편리하게 답변해 드립니다.",
    "key25": "전액 환불 보장",
    "key26": "는 경쟁력 있는 제품 가격과 효율적인 배송을 제공합니다.상품이 배송되지 않았거나 배송 후 사용할 수 없는 경우 플랫폼은 100% 환불을 약속하고 100% 재무 안전을 보장합니다.",
    "key27": "가격",
    "key28": "사이트 탐색",
    "key29": "겐신 임팩트 충전",
    "key30": "혼카이 스타 레일 탑업",
    "key31": "FC 25 코인",
    "key32": "수정",
    "key33": "브롤스타즈",
    "key34": "제휴 프로그램",
    "key35": "서비스 약관",
    "key36": "개인정보 보호정책",
    "key37": "쿠키 정책",
    "key38": "FAQ",
    "key39": "팔로우",
    "key40": "취소",
    "key41": "계정 정보",
    "key42": "아바타",
    "key43": "닉네임",
    "key44": "이메일",
    "key45": "비밀번호",
    "key46": "이미 설정됨",
    "key47": "바인드",
    "key48": "저장",
    "key49": "결제 정보",
    "key50": "참고: 입력한 주소가 은행 계좌/카드에 연결된 주소와 정확히 일치하는지 확인하세요. 그렇지 않으면 결제에 실패할 수 있습니다.",
    "key51": "국가를 선택해 주세요",
    "key52": "주를 선택해 주세요",
    "key53": "도시 입력",
    "key54": "주소 입력",
    "key55": "우편번호 입력",
    "key56": "이메일을 입력하세요",
    "key57": "휴대폰 입력",
    "key58": "전체 이름을 입력하세요.",
    "key59": "전체 성 입력",
    "key60": "전체 연도 입력",
    "key61": "전체 월 입력",
    "key62": "전체 이력서를 입력하세요.",
    "key63": "전체 카드 번호 입력",
    "key64": "은행 카드 번호",
    "key65": "CVV",
    "key66": "만료일",
    "key67": "연도",
    "key68": "월",
    "key69": "이름",
    "key70": "성",
    "key71": "국가/지역",
    "key72": "국가 선택",
    "key73": "상태 선택",
    "key74": "도시",
    "key75": "우편 번호",
    "key76": "주소",
    "key77": "전화",
    "key78": "이메일",
    "key79": "지금 결제",
    "key80": "상태",
    "key81": "빠른 배송",
    "key82": "안전 및 신뢰성",
    "key83": "배달: 즉시 충전",
    "key84": "판매량",
    "key85": "주문 정보",
    "key86": "입력된 정보를 다시 확인하세요",
    "key87": "저축",
    "key88": "지금 충전",
    "key89": "보안 보증",
    "key90": "수량",
    "key91": "가격",
    "key92": "서비스",
    "key93": "구매 내역",
    "key94": "계정 설정",
    "key95": "도움말 센터",
    "key96": "내 잔액",
    "key97": "내 포인트",
    "key98": "내 쿠폰",
    "key99": "정보 필요",
    "key100": "처리 중",
    "key101": "환불",
    "key102": "회사 소개",
    "key103": "미지급",
    "key104": "여기에는 주문이 없습니다",
    "key105": "애플리케이션 번호",
    "key106": "유료",
    "key107": "시간",
    "key108": "여기는 주문이 없습니다",
    "key109": "Fail",
    "key110": "검색",
    "key111": "항목을 찾을 수 없습니다",
    "key112": "검색 결과",
    "key113": "상위 3개 프로모터",
    "key114": "서비스 약관",
    "key115": "개인정보 보호정책",
    "key116": "쿠키 정책",
    "key117": "돈 벌기 시작",
    "key118": "링크를 공유하면 사용자가 공유 링크를 사용하여 게임을 충전하거나 플레이세이브닷컴에서 게임 코인을 구매할 때마다 수익을 얻을 수 있습니다.",
    "key119": "프로모터 리더보드",
    "key120": "성공적인 주문량",
    "key121": "소득",
    "key122": "플레이세이브닷컴 제휴 프로그램에 참여하기에 적합한 사람은 누구인가요?",
    "key123": "playsave.com은 게이머에게 할인된 가격과 더 나은 서비스를 제공하기 위해 최선을 다하고 있습니다. 게임 커뮤니티에서 같은 생각을 가진 사람들과 함께 일하면 playsave.com의 영향력을 확대하고 더 많은 게임 애호가에게 서비스를 제공할 수 있다고 믿습니다. 게임 콘텐츠 크리에이터, 유튜버, 소셜 미디어 인플루언서라면 주저하지 말고 즉시 playsave.com 제휴 프로그램에 가입하세요!",
    "key124": "playsave.com 제휴 프로그램에서 최대 얼마를 벌 수 있나요?",
    "key125": "playsave.com 제휴 프로그램의 프로모터는 생성된 각 판매에 대해 최대 10%의 수익을 얻을 수 있으며, 수익에는 한도가 없습니다!",
    "key126": "겐신 임팩트와 혼카이: 스타 레일의 신규 유저 보상 기준은 10% 복귀 유저는 2%입니다.",
    "key127": "다른 게임 재충전 또는 게임 코인 구매에 대한 보상 기준은 5% 복귀 유저는 1%",
    "key128": "보상 기준이 조정되는 경우 웹사이트에 게시된 최신 조정 내용을 참조하시기 바라며, 사업 전개에 따라 조정될 수 있습니다.",
    "key129": "기타 궁금한 사항",
    "key130": "보상 수입은 24시간 이내에 수입 세부 정보에서 확인할 수 있으며, 매주 정산되며, 인출하거나 playsave.com에서 게임에 직접 충전하도록 선택할 수 있습니다.",
    "key131": "프로모션은 합법적인 방법으로 진행해야 합니다. 부정한 방법을 통한 홍보는 허용되지 않습니다. Google 광고와 같은 방법을 통한 프로모션은 콘텐츠 크리에이터의 포지셔닝에 맞지 않고 공정성 원칙에 위배되며, 또한 허용되지 않습니다. playsave.com은 귀하의 자금을 동결할 권리가 있습니다.",
    "key132": "특정 국가의 사용자에게는 규칙 구성에 따라 보상이 제공되지 않을 수 있습니다. 웹사이트에 게시된 최신 조정 사항을 따르시기 바라며, 사업 전개 상황에 따라 조정될 수 있습니다.",
    "key133": '메시지',
    "key134": "사용자 계약",
    "key135": "본 약관 정보",
    "key136": '본 계약은 귀하와 GEARUP PORTAL PTE. (이하 "당사", "당사" 또는 "당사")와 귀하가 본 계약에 따라 게임 내 가상 아이템 및 게임 충전(이하 "가상 아이템")을 검색하고 구매할 수 있는 플레이세이브의 애플리케이션 또는 웹사이트("서비스" 또는 "플레이세이브 서비스")와 관련하여 귀하와 1 RAFFLES QUAY #49 SINGAPORE에 등록 사무소를 둔 GEARUP PORTAL PTE. 귀하는 당사 서비스에 액세스함으로써 본 계약 및 해당 서비스에 적용되는 모든 지침 또는 규칙을 준수할 것에 동의합니다.',
    "key137": "당사는 애플리케이션 또는 웹사이트에 개정된 약관을 게시하여 본 계약 및 해당 지침을 수시로 업데이트할 수 있습니다. 귀하가 당사의 서비스를 계속 사용하는 것은 귀하가 업데이트된 계약에 동의하는 것으로 간주됩니다.",
    "key138": "귀하는 본 약관을 전자적으로 입력하는 것과 본 약관과 관련된 기록을 전자 형식으로 저장하는 것에 동의합니다.",
    "key139": "플레이세이브는 가상 아이템을 검색, 구매하고 게임을 충전할 수 있는 온라인 웹사이트입니다.",
    "key140": "당사 서비스에 액세스함으로써 귀하는 각 사용자 계약 및/또는 약관 및/또는 게임 정책의 조건이 모든 측면에서 귀하에게 적용된다는 데 동의합니다.",
    "key141": "서비스를 이용하려면 거주 국가에서 성년 이상의 연령에 도달해야 하며, 그렇지 않은 경우 부모 또는 성인의 감독 하에 서비스를 이용해야 합니다.",
    "key142": '플레이세이브 서비스"를 이용하기 위해서는 반드시 본인의 SNS 계정(라인, 트위터, 페이스북 계정)을 통해 로그인해야 하며, 긴급한 경우 본인의 이메일을 첨부할 수 있습니다. 가상 아이템을 구매하기 전에 귀하는 게임 계정을 바인딩해야 하며, 이 바인딩을 통해 당사가 귀하의 공개 게임 프로필 및 가상 아이템 목록을 포함하되 이에 국한되지 않는 특정 게임 사용자 계정 정보에 접근하고 이를 사용할 수 있도록 승인합니다. 당사가 귀하로부터 수집하는 개인정보와 그 사용 방법에 대한 자세한 내용은 개인정보 처리방침"을 참조하시기 바랍니다',
    "key143": "귀하는 귀하의 계정 정보를 보호하고 기밀로 유지하기 위해 필요한 노력을 기울일 것에 동의합니다. 귀하는 당사의 사전 동의 없이 귀하의 계정과 본 계약에 따른 귀하의 권리 또는 의무를 타인에게 양도하거나 귀하의 계정 정보를 타인과 공유할 수 없음에 동의합니다.",
    "key144": "사용자 행동 및 콘텐츠",
    "key145": "귀하는 당사의 서비스를 사용할 때 귀하가 위치한 관할권의 관련 법률 또는 규정(자금세탁방지/테러자금조달방지법 또는 규정 포함), 행정 명령 또는 조치, 법원의 판결 또는 관할 당국의 결정을 따라야 합니다. 관련 법률이 귀하의 서비스 이용을 제한하거나 금지하는 경우 귀하는 그러한 제한을 따르거나 당사 서비스 이용을 중단해야 합니다.",
    "key146": "다음 중 어느 하나에 해당하는 사람이 아니어야 합니다.",
    "key147": "조직 범죄 단체의 구성원;",
    "key148": "조직 범죄 집단과 조직 범죄 집단이 그 사람의 경영에 실질적으로 관여하고 있음을 보여주는 관계에 있는 사람",
    "key149": "조직 범죄 집단에 의존하는 것으로 보이는 조직 범죄 집단과 그러한 관계를 맺고 있는 사람",
    "key150": "조직 범죄 단체에 자금을 제공하거나 이와 유사한 행위를 통해 조직 범죄 단체의 유지 또는 운영에 협력하고 관여하는 사람, 또는",
    "key151": "조직 범죄 집단과 사회적으로 비난받을 만한 관계에 있는 사람",
    "key152": '사용자는 당사의 서비스를 통해 정보, 데이터, 소프트웨어, 사운드, 사진, 그래픽, 비디오, 태그 또는 기타 자료("콘텐츠")를 전송, 업로드, 커뮤니케이션, 전송 또는 기타 방법으로 제공할 수 있습니다. 귀하는 당사의 서비스를 통해 공개적으로 게시하거나 비공개로 전송하는 모든 콘텐츠에 대해 전적으로 책임을 집니다.',
    "key153": "귀하는 불법, 유해, 위협, 학대, 괴롭힘, 불법, 명예 훼손, 저속, 외설, 비방, 타인의 사생활 침해, 혐오, 차별, 음란, 성적으로 노골적이거나 기타의 어떠한 콘텐츠도 제공하지 않습니다.",
    "key154": "귀하는 어떠한 당사자의 특허, 상표, 영업 비밀, 저작권 또는 기타 소유권을 침해하는 콘텐츠를 제공하지 않습니다.",
    "key155": "귀하는 치트, 자동화 소프트웨어(봇), 해킹, 개조 또는 서비스의 일부를 수정하거나 서비스에서 정보를 수집하도록 설계된 기타 승인되지 않은 타사 소프트웨어를 사용해서는 안 됩니다.",
    "key156": "귀하는 당사 서비스, 타인이 만든 콘텐츠 또는 그 일부의 전체 또는 일부를 기반으로 리버스 엔지니어링, 소스 코드 도출, 수정, 디컴파일, 디스어셈블 또는 파생 저작물을 생성해서는 안 됩니다.",
    "key157": "귀하는 당사의 서비스와 관련하여 특허 고지, 저작권 고지 또는 기타 지적 재산권 정보를 제거하거나 수정하지 않습니다.",
    "key158": "가상 아이템 및 게임탑업 구매",
    "key159": "귀하는 플레이세이브 서비스를 사용한 후 거래의 모든 약관을 읽고 이해할 전적인 책임이 있으며, 귀하의 행동에 대한 모든 책임을 져야 합니다.",
    "key160": "플레이세이브는 바이탈 아이템 거래 및 게임 충전으로 인해 발생하는 분쟁 해결을 위해 이용자에게 필요한 지원을 제공할 수 있습니다.",
    "key161": "환불 정책",
    "key162": "본 이용약관 또는 관련 법률에서 달리 규정하지 않는 한, 당사 서비스 내의 모든 구매는 최종적이며 환불이 불가능하며 어떠한 상품에 대해서도 환불이 불가능합니다. 당사는 귀하가 서비스를 통해 수행하는 결제 또는 거래의 결과로 발생할 수 있는 어떠한 청구 또는 손해에 대해서도 귀하 또는 제3자에게 책임을 지지 않습니다.",
    "key163": '모든 주문은 플레이세이브에서 최종적이며, 주문에 대해 정식으로 전액 결제했음에도 불구하고 주문을 받지 못한 경우를 제외하고는 환불이 제공되지 않습니다. 주문에 포함된 가상 아이템(이하 "구매한 제품")이 배송되지 않았거나 부분적으로 배송된 경우 환불이 가능합니다.',
    "key164": NaN,
    "key165": "다음과 같은 상황에서는 환불이 연장되지 않습니다.",
    "key166": "구매자가 주문 수령을 확인하고 확인했습니다.",
    "key167": "플레이세이브 웹사이트 외부에서 이루어진 거래.",
    "key168": "주문에 따라 배송된 가상 아이템에 대한 구매자의 불만족, 구매자의 후회, 잘못 구매한 가상 아이템 및/또는 구매자의 컴퓨터가 최소 제품 요구 사항을 충족하지 않는 경우.",
    "key169": "직접 충전으로 잘못 구매하거나 실수로 구매한 경우 환불이 제공되지 않습니다. 최종 결제를 진행하기 전에 제품 설명을 꼼꼼히 읽고 게임 이름, 서버, 계정 이름, 구매 금액이 정확한지 확인해야 합니다. 당사는 귀하의 과실 및/또는 제공된 허위 또는 잘못된 정보로 인해 발생한 잘못된 주문 또는 착오 주문에 대해 책임을 지지 않습니다.",
    "key170": "사기성 청구. 당사는 사기성 클레임을 제기한 구매자의 계정을 법적 조치를 취하고 영구 정지할 권리를 보유합니다.",
    "key171": "구매자는 플레이세이브 웹사이트에서 제품을 구매함으로써 앞서 언급한 제외 사항을 이해하고 인정하며 이에 동의합니다.",
    "key172": "구매자가 사용하는 결제수단 유형에 따라 환불 처리까지 일반적으로 최대 14일이 소요될 수 있습니다. 이는 은행이 일반적으로 환불을 즉시 완료하지 않으며 자금의 승인 보류가 만료되기까지 최대 14일이 소요될 수 있기 때문입니다.",
    "key173": "면책 조항",
    "key174": '당사는 귀하에게 정확하고 신뢰할 수 있는 서비스를 제공하기 위해 노력하지만, 귀하는 당사의 서비스 및 정보가 "있는 그대로" 제공됨을 명시적으로 이해하고 인정합니다. 조건, 중단 없는 사용, 상품성, 특정 목적에의 적합성, 비침해, 정확성, 신뢰성 또는 버그/오류/결함 없음에 대한 보증을 포함하되 이에 국한되지 않는 어떠한 종류의 명시적 또는 묵시적 보증 없이 "있는 그대로" 제공됩니다.',
    "key175": "회원님은 본 약관에 명시적으로 규정되거나 관련 법률에서 요구하는 당사의 책임을 제한하지 않고, 당사가 간접적, 우발적, 특별 손해에 대해 책임을 지지 않음을 명시적으로 이해하고 동의합니다, 결과적 또는 예시적 손해(이익, 영업권, 사용, 데이터 또는 기타 무형적 손실에 대한 손해를 포함하되 이에 국한되지 않음)에 대해 책임을 지지 않으며(그러한 손해의 가능성을 사전에 통지받은 경우에도 포함), 이로 인해 발생하는 손해에 대해 책임을 지지 않습니다: (i) 당사의 서비스를 이용할 수 없음, (ii) 구매 또는 획득한 상품, 데이터, 정보 또는 서비스 또는 당사의 서비스를 통해 또는 당사의 서비스를 통해 체결한 메시지 또는 거래로 인해 발생하는 대체 상품 및 서비스의 조달 비용, (iii) 귀하의 전송 또는 데이터에 대한 무단 액세스 또는 변경, (iv) 당사의 서비스에서 제3자의 진술 또는 행위, (v) 당사의 서비스와 관련된 기타 모든 문제. 어떠한 경우에도 당사의 총 책임은 계약, 불법 행위, 무과실 책임 또는 기타 사유로 발생하더라도 그러한 청구가 발생한 시점 직전 6개월 동안 귀하가 당사에 지불한 총 수수료를 초과하지 않습니다.",
    "key176": "위반 및 배상",
    "key177": " 귀하가 본 계약 또는 게시된 지침이나 규칙을 위반했다고 합리적으로 판단되는 경우, 당사는 다음을 포함하되 이에 국한되지 않고 적절하다고 판단되는 조치를 취할 수 있습니다: (i) 관련 콘텐츠 삭제, (ii) 당사 서비스에서 제공되는 모든 기능 중단, (iii) 귀하의 계정 정지, (iv) 귀하의 당사 서비스 사용 권한 종료, (v) 귀하를 상대로 법적 조치를 취하거나 관련 정보를 법 집행 기관에 공개, (vi) 게시된 지침 및 규칙에 명시된 기타 조치.",
    "key178": "귀하는 본 계약의 위반을 포함하되 이에 국한되지 않고 본 계약에 명시된 귀하와 당사 간의 관계에 따라 또는 그로 인해 발생하는 모든 제3자의 청구, 손실, 손해, 책임, 비용 및 경비에 대해 당사를 면책하고 당사를 보호해야 합니다. 귀하는 당사가 원하는 변호사를 선택하고 그러한 청구, 요구 또는 소송을 타협하거나 해결할 수 있는 권리를 포함하여 그러한 청구, 요구 또는 소송에 대한 법적 방어를 통제할 권리를 갖는다는 데 동의합니다.",
    "key179": "지적 재산",
    "key180": "플레이세이브 및 관련 로고와 이름은 당사의 상표 및/또는 서비스 마크입니다. 서비스에 사용된 기타 상표, 이름 및 로고는 해당 소유자의 상표, 서비스 마크 또는 로고입니다. 귀하는 앞서 언급한 상표, 서비스 마크 또는 로고와 관련하여 어떠한 권리나 라이선스도 부여받지 않습니다.",
    "key181": "서비스 및 이와 관련된 모든 관련 데이터, 콘텐츠 및 소프트웨어는 저작권, 상표, 특허, 영업 비밀 및/또는 기타 법률의 보호를 받으며, 당사는 서비스에 대한 모든 권리(지적 재산권 및 소유권을 포함하되 이에 국한되지 않음)를 보유 및 보유합니다. 본 계약의 이용약관 및 게시된 관련 지침 또는 규칙에 따라, 당사는 귀하에게 당사의 서비스와 관련하여 귀하의 개인적인 용도로만 당사의 서비스를 사용 및 복제할 수 있는 제한적이고, 취소 가능하며, 재라이선스가 불가능하고, 비독점적인 라이선스를 부여합니다. 여기에 명시적으로 규정되지 않는 한, 귀하는 당사의 서비스 또는 그 각색물을 복제, 배포, 대중에게 배포, 제공, 개조, 공개 공연 또는 공개적으로 전시할 수 없습니다. 귀하가 본 계약을 위반하는 경우 본 계약에 따라 부여된 라이선스는 자동으로 해지됩니다. 일부 서비스는 애플리케이션 또는 당사 웹사이트에 명시된 대로 오픈 소스 라이선스와 같은 특정 제3자의 라이선스의 적용을 받을 수 있습니다. 특정 서비스를 이용할 때는 해당 제3자의 라이선스 계약을 주의 깊게 읽고 해당 계약에 명시된 요구사항을 준수해야 합니다.",
    "key182": "기타",
    "key183": "전체 계약",
    "key184": "본 계약은 귀하와 당사 간의 완전한 합의를 명시하며, 귀하와 당사 간에 존재했을 수 있는 기타 모든 이전 또는 동시대의 계약, 이해 또는 협상을 대체하고 이를 대체합니다.",
    "key185": "분리 가능성",
    "key186": "본 계약의 조항이 불법, 집행 불가능 또는 무효로 선언되거나 판명되는 경우, 해당 조항에 따라 발생하는 모든 의무가 면제되며, 본 계약은 그 의도를 유지하면서 합법적이고 집행 가능하게 만드는 데 필요한 범위까지 해당 조항을 수정하여 수정된 것으로 간주하는 것이 귀하와 당사의 의도 및 동의입니다.",
    "key187": "당사의 권리 포기",
    "key188": "당사가 본 계약의 조항을 언제든지 또는 일정 기간 동안 집행하지 못한다고 해서 해당 조항의 포기 또는 이후 각 조항을 집행할 수 있는 당사의 권리를 포기하는 것으로 해석되어서는 안 됩니다. 본 계약을 구체적으로 언급하고 당사가 정식으로 서명한 서면 문서에 명시되지 않는 한 본 계약의 어떠한 조항이나 조건에 대한 포기도 유효하거나 당사에 구속력이 없습니다.",
    "key189": NaN,
    "key190": "문의하기",
    "key191": '본 사용자 계약 또는 당사의 개인정보 보호 관행에 대해 더 궁금한 점이 있으면 플레이세이브 웹사이트의 "지원팀에 문의"를 통해 문의하시기 바랍니다.',
    "key192": "언어",
    "key193": "본 계약은 해당 지역의 현지 언어로 번역될 수 있습니다. 본 계약의 영어 버전과 현지화 버전이 상충하는 경우 영어 버전이 우선합니다.",
    "key194": "준거법 및 장소",
    "key195": "관련 법률에 달리 규정되지 않는 한, 본 계약은 싱가포르의 법률 충돌 규정과 관계없이 전적으로 싱가포르에서 이행, 협상 및 실행되는 계약으로서 싱가포르 법률의 적용을 받습니다. 귀하의 당사 서비스 이용 또는 본 계약에 따라 또는 그로 인해 발생하는 모든 분쟁은 싱가포르 국제중재센터(\"SIAC\")가 주관하는 중재에 구속력을 갖습니다. 귀하는 이에 따라 SIAC의 대인 관할권 및 재판지에 동의합니다. 귀하가 유럽경제지역 거주자인 경우, 귀하는 귀하가 거주하는 국가의 법률(분쟁 해결 장소 관련 포함)의 모든 의무 조항의 혜택을 받게 됩니다.",
    "key196": NaN,
    "key197": "마지막 업데이트: 2024년 8월 26일",
    "key198": NaN,
    "key199": "환영합니다",
    "key200": '본 개인정보 처리방침은 귀하가 본 개인정보 처리방침에 링크된 당사의 서비스를 이용할 때 당사가 귀하의 개인정보(이하 "개인정보"라고도 함)를 수집, 사용 및 공유하는 방법에 대한 정보를 제공합니다. 또한 귀하의 개인정보와 관련된 귀하의 법적 권리 및 선택권에 대해서도 설명합니다. 귀하의 당사 서비스 액세스 및 사용은 "\"개인정보 처리방침\"의 적용을 받습니다',
    "key201": "이용 약관",
    "key202": "당사는 수시로 본 개인정보 처리방침을 다시 업데이트할 수 있습니다. 본 개인정보 처리방침이 업데이트된 후에도 서비스를 계속 사용함으로써 귀하는 개인정보가 최신 버전에 따라 처리됨을 인정하는 것입니다.",
    "key203": "섹션으로 이동:",
    "key204": "귀하의 개인 정보",
    "key205": "당사가 수집하는 개인 정보",
    "key206": "개인 정보 사용 방법",
    "key207": "당사가 개인 정보를 공유하는 방법",
    "key208": "귀하의 개인정보 보호 권리 및 선택권",
    "key209": "귀하의 권리 행사",
    "key210": "광고 및 마케팅 수신 거부",
    "key211": "쿠키 및 유사 기술",
    "key212": "부모 및 보호자를 위한 정보",
    "key213": "지역 정보",
    "key214": "미국 거주자를 위한 추가 정보",
    "key215": "회사 소개",
    "key216": "당사가 수집하는 개인 정보",
    "key217": "개인정보는 식별되거나 식별 가능한 개인으로서 귀하와 관련된 모든 정보 또는 데이터입니다. 다음은 당사가 당사 서비스 사용자에 대해 수집하는 개인정보의 범주입니다.",
    "key218": "귀하가 제공한 정보:",
    "key219": "귀하가 당사와 상호 작용하는 방식에 따라 당사는 귀하에게 다음 정보 중 하나 이상의 정보를 제공하도록 요청할 수 있습니다. 당사는 서비스를 적절하게 운영하기 위해 특정 목적을 위해 필요한 경우에만, 그리고 귀하가 제공하기로 선택한 경우에만 귀하로부터 이러한 정보를 수집합니다.",
    "key220": "신원, 연락처 인구통계학적 세부 정보(예: 이름, 화면 이름 또는 기타 유사한 고유 식별자, 직책, 생년월일/나이, 국가/지역, 정부 발급 신분증, 이메일/전화 번호/우편 주소, 메시징/소셜 계정 ID)",
    "key221": "청구 및 거래 데이터(청구/배송 주소, 결제 또는 금융 계좌 세부 정보, 당사와의 구매 및 거래에 대한 세부 정보)",
    "key222": "계정 프로필 정보(회원님이 만든 계정의 사용자 아이디와 비밀번호, 보안 질문과 답변, 아바타, 타사 소셜 미디어 또는 게임 플랫폼 계정 ID, 계정 또는 프로필을 통해 공유하는 기타 정보)",
    "key223": "사용자 생성 콘텐츠(귀하가 당사 서비스 내에서 생성, 공유 또는 업로드한 콘텐츠, 아이템 또는 자산, 당사 서비스에 대한 귀하의 피드백, 리뷰 또는 의견, 당사 소셜 미디어 사이트에 대한 귀하의 게시물, 댓글 및 참여)",
    "key224": "사용 데이터 기본 설정(쿠키 및 유사 기술에 관한 귀하의 선택, 게임 플레이 설정, 언어 및 관심사, 기타 표현된 기본 설정을 포함하여 귀하가 서비스를 사용하고 구성하는 방법에 관한 정보)",
    "key225": "설문 조사 데이터(사용자 설문 조사 또는 연구에서 자발적으로 제공한 정보)",
    "key226": "마케팅 기본 설정(뉴스레터, 설문조사 및 기타 프로모션 콘텐츠 수신에 대한 기본 설정을 포함하여 귀하에게 표시되거나 제공되는 마케팅/광고에 대한 귀하의 선택)",
    "key227": "당사와의 커뮤니케이션(이메일, 채팅 및 기타 당사와의 메시지 세부 정보)",
    "key228": "당사가 자동으로 수집하는 정보: 당사는 일반적으로 귀하가 당사 서비스를 방문, 액세스 또는 사용할 때 다음 유형의 정보를 자동으로 수집합니다.",
    "key229": "위치 정보(IP 주소, 셀 ID 및 Wi-Fi 연결을 기반으로 한 도시/국가/지역)",
    "key230": "기기, 네트워크 및 기술 정보(IP/MAC 주소 및 기타 유사한 기기 식별자, 기기 모델, 운영 체제, 지역/언어 설정, 인터넷 서비스 공급자, 화면 해상도, 프레임 속도 및 핑 값, 스택 정보(예: 충돌 보고서 및 코어 덤프) 및 서버 상태 지표(예: CPU 및 메모리 사용량, I/O 사용량 및 로드 평균), 서비스 내 작업 및 이벤트의 날짜 및 시간 스탬프, 기타 네트워크 및 기술 정보)",
    "key231": "당사가 제3자로부터 수집하는 정보: 경우에 따라 당사는 제3자로부터 귀하에 대한 정보를 받을 수 있습니다.",
    "key232": "귀하가 당사 서비스에서 제3자 계정을 바인딩, 연결 또는 로그인하기로 선택할 때 귀하가 승인한 소셜 미디어 또는 게임 플랫폼 계정 정보(당사가 받는 구체적인 정보는 제3자에 따라 다르며 플랫폼 계정 ID, 플랫폼 이름, 프로필 사진, 친구 목록, privacy@playsave.com, 연령, 국가/지역을 포함할 수 있으며 플랫폼에서 당사에 공유하는 정보를 검토하거나 조정하려면 사용하는 특정 플랫폼의 계정 설정을 참조하세요)",
    "key233": "제3자 결제 처리 서비스를 사용하기로 선택한 경우의 결제 정보(예: 해시 식별자, 결제의 출처 국가/지역, 거래 세부 정보)",
    "key234": "당사 서비스, 당사가 귀하에게 보내는 커뮤니케이션 또는 기타 관련 사이트 또는 앱의 콘텐츠에 대한 귀하의 참여에 관한 광고 또는 마케팅 데이터",
    "key235": "민감한 정보. 주민등록번호, 종교, 정치적 성향, 성적 지향, 인종/민족 정보, 범죄 이력, 노동조합/협회 가입 여부 등 민감한 정보나 '특수 범주 데이터'는 보내지 마세요.",
    "key236": "개인 정보 사용 방법",
    "key237": "당사는 정보를 수집한 목적으로만 개인정보를 사용합니다. 관련 데이터 보호법에 따라 회사는 사용자의 개인정보를 처리할 법적 근거가 있어야 합니다. 아래에서는 개인 정보 처리의 목적과 법적 근거를 설명합니다.",
    "key238": "당신이 하는 일",
    "key239": "우리가 수집하는 것",
    "key240": "수집하는 이유",
    "key241": "법적 근거",
    "key242": "서비스 사용(예: 웹사이트 방문, 계정 가입)",
    "key243": "신원, 연락처 및 인구통계학적 세부 정보",
    "key244": "청구 및 거래 정보",
    "key245": "계정 및 프로필 정보",
    "key246": "사용자 생성 콘텐츠",
    "key247": "사용 데이터 및 환경 설정",
    "key248": "설문조사 및 연구 데이터",
    "key249": "마케팅 기본 설정",
    "key250": "당사와의 커뮤니케이션",
    "key251": "위치 정보",
    "key252": "장치, 네트워크 및 기술 정보",
    "key253": "게임플레이 정보",
    "key254": "소셜 미디어 또는 게임 플랫폼 계정 정보",
    "key255": "결제 정보",
    "key256": "광고 또는 마케팅 데이터",
    "key257": "다음과 같은 서비스를 운영하고 귀하에게 제공하기 위해",
    "key258": "장치에서 당사 소프트웨어를 다운로드, 설치 및 실행할 수 있도록 합니다",
    "key259": "환경 설정을 사용자 지정하고 맞춤형 경험을 제공할 수 있습니다",
    "key260": "다른 사용자와 연결하고 상호 작용할 수 있도록 합니다",
    "key261": "서비스에 대해 귀하와 소통하기",
    "key262": "서비스 및 당사의 비즈니스 문제를 해결하고 개선하기 위해 다음을 포함합니다.",
    "key263": "시스템 디버깅, 문제 해결 및 진단 테스트",
    "key264": "당사 시스템 및 서비스의 성능 분석 수행",
    "key265": "새로운 시스템 및 서비스 기능 테스트 중",
    "key266": "시스템 및 로그 유지 관리",
    "key267": "기술 지원 제공",
    "key268": "서비스의 안전, 보안 및 무결성을 증진하기 위해 다음을 포함합니다.",
    "key269": "사기, 치트/해킹 및 기타 금지된 행위의 식별, 예방 및 단속",
    "key270": "커뮤니티 표준 관리",
    "key271": "부적절한 콘텐츠 조정 중",
    "key272": "사용자 신고에 응답하기",
    "key273": "다음과 같은 당사의 서비스 운영과 관련된 법적 의무를 준수하기 위해",
    "key274": "연령 보장 및 확인 조치 구현",
    "key275": "\"고객 파악\" 요구 사항 완료",
    "key276": "유효한 법적 요청에 응답",
    "key277": "사업 장부 및 기록 유지",
    "key278": "다음을 포함하여 비즈니스를 운영하고 관리하기 위해",
    "key279": "내부 감사 수행 중",
    "key280": "합병, 인수 및 기타 조직 개편 또는 구조조정 촉진(장래 거래 포함)",
    "key281": "귀하와의 계약 이행(이용 약관)",
    "key282": "수집 시 귀하에게 공개된 특정 처리 목적과 관련하여 귀하의 동의",
    "key283": "우리의 정당한 이익:",
    "key284": "서비스 및 당사 비즈니스의 운영, 문제 해결 및 개선",
    "key285": "귀하와의 계약 이행 외의 안전, 보안 및 무결성 증진",
    "key286": "사용자와 사용자가 서비스와 상호 작용하는 방식 이해",
    "key287": "서비스에 관한 내부 분석 수행",
    "key288": "법적 요건을 준수하거나 당사의 법적 권리를 방어합니다",
    "key289": "서비스 제공과 관련된 당사의 법적 의무 이행",
    "key290": "서비스 계정에 가입하거나 타사 플랫폼 계정으로 바인딩, 연결 또는 로그인",
    "key291": "신원, 연락처 및 인구통계학적 세부 정보",
    "key292": "계정 및 프로필 정보",
    "key293": "사용 데이터 및 환경 설정",
    "key294": "당사와의 커뮤니케이션",
    "key295": "위치 정보",
    "key296": "장치, 네트워크 및 기술 정보",
    "key297": "게임플레이 정보",
    "key298": "소셜 미디어 또는 게임 플랫폼 계정 정보",
    "key299": "귀하가 서비스에서 계정/프로필을 설정하여 맞춤화되고 지속적인 경험을 제공하고 귀하의 계정에 대해 귀하와 소통할 수 있도록 하기 위해",
    "key300": "다음과 같은 계정 생성 및 유지 관리와 관련된 법적 의무를 준수하기 위해",
    "key301": "연령 보장 및 확인 조치 구현",
    "key302": "신원 인증 및 정보 보호",
    "key303": "귀하와의 계약 이행(이용 약관)",
    "key304": "계정 설정 시 귀하의 동의",
    "key305": "서비스를 운영 및 개선하고 법적 요건을 준수하거나 당사의 법적 권리를 방어하기 위한 당사의 정당한 이익",
    "key306": "제품 또는 서비스 구매(가상 상품 및 가상 포인트와 같은 디지털 콘텐츠 포함)",
    "key307": "신원, 연락처 및 인구통계학적 세부 정보",
    "key308": "결제 및 거래 정보",
    "key309": "계정 및 프로필 정보",
    "key310": "사용 데이터 및 환경설정",
    "key311": "당사와의 커뮤니케이션",
    "key312": "게임플레이 정보",
    "key313": "주문 처리 및 배송 또는 디지털 콘텐츠에 대한 액세스 권한 제공을 포함하여 구매 계약을 이행하기 위해",
    "key314": "불만 처리 또는 환불 관리 등 소비자 구매와 관련된 법적 의무를 준수하고 당사의 법적 권리를 방어하기 위해",
    "key315": "귀하와의 계약 이행(구매 계약)",
    "key316": "구매에 대한 귀하의 동의",
    "key317": "법적 요건을 준수하거나 당사의 법적 권리를 방어하기 위한 당사의 정당한 이익",
    "key318": "귀하의 구매와 관련된 당사의 법적 의무 이행",
    "key319": "위치 기반 기능 사용 또는 활성화",
    "key320": "위치 정보",
    "key321": "지역별 게임 내 이벤트, 토너먼트, 경기 등 사용자가 요청한 위치 기반 서비스 및 기능을 제공하기 위해",
    "key322": "귀하와의 계약 이행(이용 약관)",
    "key323": "위치 기반 기능을 활성화할 때의 동의",
    "key324": "고객 지원 문의",
    "key325": "신원, 연락처 및 인구통계학적 세부 정보",
    "key326": "청구 및 거래 정보",
    "key327": "계정 및 프로필 정보",
    "key328": "사용자 생성 콘텐츠",
    "key329": "사용 데이터 및 환경 설정",
    "key330": "당사와의 커뮤니케이션",
    "key331": "장치, 네트워크 및 기술 정보",
    "key332": "게임플레이 정보",
    "key333": "소셜 미디어 또는 게임 플랫폼 계정 정보",
    "key334": "다음과 같은 서비스와 관련된 고객 지원을 제공합니다.",
    "key335": "사용자 문의, 요청, 의견 및 불만 사항 처리",
    "key336": "요청하신 정보 전송",
    "key337": "서비스 사용 지원",
    "key338": "서비스 및 고객 지원 제공과 관련하여 법적 의무를 준수하고 당사의 법적 권리를 방어하기 위해",
    "key339": "귀하와의 계약 이행(이용 약관)",
    "key340": "귀하의 특정 문의 또는 요청과 관련된 귀하의 동의",
    "key341": "사용자와 사용자가 서비스와 상호 작용하는 방식을 이해하고 법적 요건을 준수하거나 당사의 법적 권리를 방어하기 위한 당사의 정당한 이익",
    "key342": "고객 지원과 관련된 당사의 법적 의무 이행",
    "key343": "뉴스레터 중 하나를 구독하거나 설문조사, 콘테스트 또는 프로모션에 참여하세요",
    "key344": "신원, 연락처 및 인구통계학적 세부 정보",
    "key345": "계정 및 프로필 정보",
    "key346": "사용 데이터 및 환경설정",
    "key347": "설문조사 및 연구 데이터",
    "key348": "마케팅 기본 설정",
    "key349": "당사와의 커뮤니케이션",
    "key350": "장치, 네트워크 및 기술 정보",
    "key351": "게임플레이 정보",
    "key352": "소셜 미디어 또는 게임 플랫폼 계정 정보",
    "key353": "광고 또는 마케팅 데이터",
    "key354": "당사의 서비스를 홍보하고 새로운 릴리스, 업데이트, 혜택, 설문조사 및 당사에 관한 기타 뉴스를 알리기 위해",
    "key355": "보상, 콘테스트 및 기타 프로모션 혜택에 대해 알리고 관리하기 위해",
    "key356": "당사 서비스를 개선하기 위해 당사 사용자 기반 및 사용자 경험에 대한 분석 및 연구를 수행하기 위해",
    "key357": "관련 커뮤니케이션에 가입할 때 귀하의 동의",
    "key358": "당사의 서비스를 개선 및 홍보하고 플레이어와의 관계를 관리하기 위한 당사의 정당한 이익",
    "key359": "타사 플랫폼(예: Facebook 팬 페이지, Discord 커뮤니티)에서 당사 또는 당사 콘텐츠에 참여하세요.",
    "key360": "신원, 연락처 및 인구통계학적 세부 정보",
    "key361": "계정 및 프로필 정보",
    "key362": "사용 데이터 및 환경 설정",
    "key363": "당사 서비스에 대한 댓글, 게시물, 피드백, 리뷰 및 기타 메시지를 촉진하고 이에 응답하기 위해",
    "key364": "당사의 서비스를 운영, 홍보 및 관심 있는 개인과 소통하기 위한 당사의 정당한 이익",
    "key365": "데이터 보존:  당사는 법률, 규제, 세금, 회계 또는 보고 요건을 충족하는 등 수집 목적을 달성하는 데 합리적으로 필요한 기간 동안만 개인 정보를 보유합니다. 당사는 불만이 제기되거나 법적 소송이 제기될 가능성이 있는 경우 귀하의 개인 데이터를 더 오랜 기간 동안 보관할 수 있습니다.",
    "key366": "데이터 보안: 당사는 귀하의 정보를 우발적 또는 무단 손실, 오용, 접근, 공개, 변경 또는 파기로부터 보호하기 위해 적절한 관리적, 기술적, 물리적 안전장치를 구현합니다. 당사는 회원님의 정보가 무단으로 공개되었음을 알게 되는 경우 법에서 요구하는 바에 따라 회원님께 통지하고 회원님의 정보를 보호하기 위한 조치를 취할 것입니다. 그러나 인터넷 전송이 완전히 안전하거나 오류가 없는 것은 없으므로 온라인에서 정보를 공개할 때는 이 점을 염두에 두시기 바랍니다.",
    "key367": "당사가 개인 정보를 공유하는 방법",
    "key368": "당사는 본 개인정보 처리방침에 설명된 제한된 목적(이용약관 시행, 서비스 보안 또는 법률 또는 법적 절차에 의해 요구되는 경우 등)을 제외하고 귀하의 연락처 정보(예: 이름, 전화번호, 이메일 또는 우편 주소)를 귀하 모르게 독립적인 제3자와 공유하지 않습니다.",
    "key369": "당사는 아래에 설명된 대로 제3자와 개인 정보를 공유합니다.",
    "key370": "소셜 미디어 및 게임 플랫폼. 귀하가 타사 소셜 미디어 또는 게임 플랫폼 계정을 바인딩, 연결 또는 로그인하도록 선택하면 타사 서비스는 자체 개인정보 취급방침에 따라 귀하가 당사 서비스와 상호 작용하는 방식에 대한 정보를 수신할 수 있습니다. (예를 들어 Xbox 계정을 사용하여 당사 게임에 로그인하는 경우 Microsoft는 사용자가 게임에 로그인한 정보를 수신할 수 있습니다.) 당사는 이러한 타사의 개인정보 처리방침을 통제하지 않으므로 사용하는 타사 서비스의 정책을 반드시 검토하시기 바랍니다.",
    "key371": "서비스 제공업체. 당사는 위에서 설명한 목적을 위해 당사를 대신하여 운영되는 서비스 제공업체와 귀하의 정보를 공유합니다(개인정보 사용 방법 참조). 서비스 제공업체는 당사의 지침에 따라 당사의 서비스를 지원하며 정보를 안전하게 처리해야 합니다.  (서비스 제공업체의 예로는 클라우드 서비스, 결제 처리업체, 사용자 조사 제공업체, 마케팅 및 광고 네트워크 등이 있습니다.)",
    "key372": "관련 회사. 당사는 본 개인정보 처리방침에 부합하는 목적을 위해 계열사 및 자회사와 귀하의 정보를 공유합니다.",
    "key373": "사업 양도. 당사가 기업 매각, 합병, 조직 개편, 해산 또는 이와 유사한 사건 또는 그러한 사건과 관련된 실사에 관여하는 경우 귀하의 정보가 양도된 자산의 일부가 될 수 있습니다.",
    "key374": "법적 요건 및 피해 예방. 당사는 법률, 규정 또는 기타 법적 절차나 의무를 준수하기 위해 필요하다고 합리적으로 판단되는 경우 귀하의 정보를 공개할 수 있습니다. 당사는 당사 또는 당사의 사용자에 대한 피해를 방지하거나 당사의 권리 및 사용자의 권리를 보호하기 위해 귀하의 정보를 공개할 수 있습니다.",
    "key375": "데이터 이전: 당사의 서비스 제공업체, 계열사 및 자회사, 파트너는 전 세계 여러 국가에 위치하고 있습니다. 귀하의 개인 정보는 귀하가 거주하는 지역과 다를 수 있는 이러한 국가로 전송되어 처리될 수 있습니다. 이러한 국가에는 귀하의 관할권과 다른 데이터 보호법이 적용될 수 있으며, 경우에 따라서는 보호 수준이 낮을 수도 있습니다. 이러한 법인은 해당 데이터 보호법을 준수하여 정보를 처리하고 귀하의 정보를 보호하기 위해 적절한 보안 조치를 시행할 것을 약속합니다.",
    "key376": "EEA/영국/스위스: 이러한 국가로부터 개인정보를 전송할 때 다음과 같은 안전 장치를 구현합니다.",
    "key377": "적정성 결정: 당사는 캐나다, 일본 및 영국으로 데이터를 전송하기 위해 적정성 결정에 의존합니다.",
    "key378": "표준 계약 조항: 당사는 싱가포르 및 홍콩과 같이 적절하지 않은 것으로 간주되는 국가로의 전송에 대해 유럽위원회 및 영국 ICO에서 발행한 표준 계약 조항을 따릅니다. 당사에 연락하여 이러한 조치의 사본을 받을 수 있습니다.",
    "key379": "귀하의 개인정보 보호 권리 및 선택권",
    "key380": "귀하의 권리 행사",
    "key381": "거주 지역에 따라 귀하는 귀하의 개인정보와 관련하여 아래 나열된 권리 중 일부 또는 전부를 가질 수 있습니다. 그러나 이러한 권리는 절대적인 것은 아니며 특정 상황에서만 적용될 수 있습니다.",
    "key382": "액세스 및 이동성: 개인 정보에 대한 액세스 또는 사본 요청.",
    "key383": "삭제: 개인 정보를 삭제합니다.",
    "key384": "수정: 부정확한 개인 정보를 수정하거나 업데이트하세요.",
    "key385": "이의 제기: 개인 정보 처리에 반대하거나 개인 정보 처리를 제한하도록 요청하세요.",
    "key386": "동의 철회: 해당되는 경우, 철회 전에 이미 수행된 처리 또는 기타 합법적인 근거에 따른 개인 정보 처리에 영향을 미치지 않고 동의를 철회할 수 있습니다.",
    "key387": "불만: 귀하의 개인 정보 처리에 대해 데이터 보호 기관에 불만을 제기하세요.  ",
    "key388": "귀하는 거주지 또는 근무지 또는 당사가 데이터 보호법을 침해했다고 생각하는 EEA 국가의 데이터 보호 기관 또는 영국 정보 위원회 사무소에 클레임을 제기할 수 있습니다(해당되는 경우). ",
    "key389": "귀하는 당사에 개인정보 보호 권리 행사 요청을 PRIVACY@playsave.com 으로 제출할 수 있습니다. 메시지 제목에 \"개인정보 보호 권리 요청\"을 포함하시기 바랍니다. 당사는 이러한 권리 행사로 인해 귀하를 차별하지 않습니다.",
    "key390": "귀하의 신원을 확인하고 사기성 요청으로부터 보호하기 위해 당사는 귀하의 요청을 처리하기 전에 귀하의 신원 및 당사와의 상호 작용에 관한 추가 정보를 요청할 수 있습니다. 비밀번호로 보호된 계정을 유지하는 경우, 당사는 계정에 대한 기존 인증 관행을 통해 귀하의 신원을 확인할 수 있습니다.",
    "key391": "당사가 귀하의 요청을 거부하는 경우, 귀하는 당사에 연락하여 당사의 결정에 이의를 제기할 수 있습니다.",
    "key392": "광고 및 마케팅 수신 거부",
    "key393": "당사는 광고 및 마케팅 제공업체와 제휴하여 당사 서비스에 대한 광고를 게재하고 타사 서비스에서 당사의 광고 실적을 측정합니다. 법에서 요구하는 경우, 당사는 광고 및 마케팅 목적으로 귀하의 정보를 공유하기 전에 귀하의 동의를 구합니다. 귀하는 언제든지 PRIVACY@playsave.com 으로 이메일을 보내 동의를 철회하거나 옵트아웃할 수 있습니다.",
    "key394": "당사는 또한 이메일 및 푸시 알림을 사용하여 서비스에 대한 마케팅 메시지를 발송합니다. 이메일 메시지를 수신 거부하려면 이메일에 포함된 수신 거부 지침을 따르거나 PRIVACY@playsave.com 으로 문의하시기 바랍니다. 푸시 알림을 비활성화하려면 기기 설정에서 관련 앱을 선택하세요.",
    "key395": "쿠키 및 유사 기술",
    "key396": "당사는 쿠키 및 유사한 기술을 사용하여 브라우저 유형, 서비스 이용 시간, 방문한 페이지, 언어 기본 설정 및 기타 트래픽 데이터와 같은 정보를 수집합니다. 당사는 현재 브라우저의 추적 금지 신호에는 응답하지 않습니다. 쿠키 사용 방법에 대해 자세히 알아보거나 쿠키 수집 및 사용을 거부하려면 사용 중인 특정 서비스에 적용되는 쿠키 정책을 참조하시기 바랍니다.",
    "key397": "브라우저에서 모든 쿠키를 삭제하거나 특정 사이트의 쿠키만 허용하거나 쿠키가 전송되는 시기를 표시하도록 허용할 수 있습니다. 자주 사용하는 브라우저에서 쿠키를 관리하는 방법에 대한 지침은 다음에서 확인할 수 있습니다: 인터넷 익스플로러, 파이어폭스, 크롬, 사파리(iOS), 사파리(Mac), 오페라. 필수 쿠키를 비활성화하지 않으면 사이트가 제대로 작동하지 않을 수 있습니다.",
    "key398": "부모 및 보호자를 위한 정보",
    "key399": "당사 서비스는 일반 사용자를 대상으로 합니다. 어린 플레이어에게 어필할 수 있는 특정 서비스의 경우, 당사는 플레이어의 연령을 확인하고, 아동의 개인정보 처리에 대해 확인 가능한 부모의 동의를 요구하며, 아동의 개인정보를 보호하기 위해 높은 수준의 개인정보 보호 기본 설정을 구현하는 조치를 취합니다. 이러한 조치에는 다음 사항도 포함됩니다.",
    "key400": "부모와 보호자에게 당사가 자녀로부터 수집, 사용 및 공개할 수 있는 개인 정보에 대한 서비스별 개인정보 보호 고지를 제공합니다.",
    "key401": "법에서 요구하는 대로 아동의 개인 정보를 처리하기 위해 확인 가능한 부모의 동의를 구합니다.",
    "key402": "서비스 제공에 합리적으로 필요한 범위로 아동의 개인 정보 처리 제한",
    "key403": "자녀의 개인정보 설정에 대한 가시성과 세분화된 제어가 가능하도록 자녀 보호 기능을 제공합니다.",
    "key404": "특히 어린 플레이어를 위한 개인 정보 제공.",
    "key405": "부모와 보호자는 언제든지 privacy@playsave.com 으로 연락하여 자녀의 개인정보 추가 처리에 대한 허가를 철회하거나 자녀의 계정과 관련하여 수집한 개인정보를 삭제하도록 요청할 수 있습니다.",
    "key406": "자녀가 귀하의 동의 없이 개인정보를 처리하는 서비스를 이용하고 있다고 생각되면 privacy@playsave.com 으로 문의하시기 바랍니다.",
    "key407": "이 섹션의 목적상 \'아동\' 또는 \'어린이\'는 현지 관련 법률에서 요구하는 디지털 동의 연령에 미달하는 미성년자를 의미합니다. (예를 들어, 영국에서 디지털 동의 연령은 13세입니다.)",
    "key408": "지역 정보",
    "key409": "미국 거주자를 위한 추가 정보",
    "key410": "이 섹션에서는 위의 정보를 보완하고 당사가 당사의 서비스를 사용하는 미국 소비자에 대해 수집한 개인정보를 수집, 사용 및 공개하는 방법을 추가로 설명합니다.",
    "key411": "당사의 개인정보 수집 및 이용. 위에서 설명한 바와 같이 당사는 다양한 목적으로 개인정보를 수집하지만, 당사가 정보를 수집하는 주된 이유는 서비스를 제공하고 운영하기 위해서입니다. 당사는 다음과 같은 범주의 개인정보를 수집합니다.",
    "key412": "식별자(사용자 이름, privacy@playsave.com, IP 주소, 디바이스 식별자 및 기타 유사한 식별자를 포함한 연락처 정보 및 고유 개인 식별자)",
    "key413": "캘리포니아의 고객 기록법에 정의된 개인 정보(연락처 정보 및 제공하기로 선택한 경우 신체적 특징 또는 설명 등)",
    "key414": "귀하가 제공하기로 선택한 경우 인구통계학적 정보(생년월일/성별), 상업적 정보(구매 또는 소비 이력, 성향 또는 선호도) 형태의 보호 대상 분류의 특성",
    "key415": "인터넷 또는 전자 네트워크 활동(앱, 게임 또는 웹사이트 사용과 관련된 정보)",
    "key416": "대략적인 지리적 위치 데이터(국가/지역);",
    "key417": "오디오, 전자, 시각 또는 이와 유사한 정보(예: 프로필 사진, 사용자 생성 콘텐츠 또는 음성 채팅)",
    "key418": "관련 법률에 정의된 기타 '개인 정보'(예: 신용카드 또는 직불카드 정보)",
    "key419": "이러한 범주(예: IP 주소를 기반으로 한 도시/국가/지역)에서 도출된 추론",
    "key420": "액세스 자격 증명과 결합된 계정 로그인과 관련된 민감한 개인 정보입니다.",
    "key421": "당사가 개인정보를 사용하는 방법' 섹션에서는 개인정보를 수집하는 비즈니스 및 상업적 목적에 대해 설명합니다. '개인정보 공유 방법' 섹션에서는 당사가 개인정보를 공유하는 제3자 및 그 목적을 설명합니다.",
    "key422": "귀하의 권리. 위의 '귀하의 권리 행사'에 설명된 개인정보 보호 권리 외에도 귀하는 다음과 같은 권리를 가질 수 있습니다",
    "key423": "판매를 거부할 권리: 귀하는 당사가 귀하의 데이터를 판매하는지 여부를 알고, 판매할 경우 판매를 거부할 권리가 있습니다. 당사는 사용자의 개인 정보를 판매하지 않습니다.",
    "key424": "행동 광고를 위한 공유를 거부할 권리: 귀하는 행동 광고 목적으로 귀하의 개인 정보 공유를 거부할 권리가 있습니다. 앱 내 고객 서비스 또는 이메일(privacy@playsave.com)을 통해 당사에 연락하여 이 공유를 거부할 수 있습니다.",
    "key425": "공인 대리인: 서면 또는 위임장을 통해 귀하를 대신하여 귀하의 권리를 행사하도록 요청할 권한 있는 대리인을 지정하세요. 대리인의 요청을 수락하기 전에 당사는 대리인에게 귀하가 대리인에게 귀하를 대신하여 행동하도록 승인했다는 증거를 제시하도록 요구합니다.",
    "key426": "특정 브라우저 플러그인은 글로벌 개인정보 보호 컨트롤(\"GPC\")과 같은 수신 거부 기본 설정 신호를 전달하기 위한 옵션을 제공합니다. 당사는 GPC 신호를 타겟 광고 또는 GPC 신호를 전송하는 귀하의 브라우저 또는 장치와 관련된 개인정보의 '공유'를 거부하는 요청으로 간주합니다. 계정에 로그인하지 않은 경우, 귀하의 브라우저 또는 디바이스와 계정 간의 연결이 당사에 알려지지 않으므로 GPC 신호를 통한 요청은 계정 정보로 확장되지 않습니다.",
    "key427": "당사는 직접 마케팅 목적으로 제3자와 개인 정보를 공유하지 않습니다.",
    "key428": "당사는 16세 미만 미성년자의 개인정보를 고의로 '판매'하거나 '공유'하지 않습니다.",
    "key429": "공개적으로 게시된 콘텐츠의 삭제. 귀하가 캘리포니아에 거주하며 서비스에 등록된 사용자인 경우, 귀하는 당사에 이메일(privacy@playsave.com)을 보내거나 게임 내 고객 서비스에 연락하여 18세 미만일 때 서비스에 게시한 콘텐츠 또는 정보를 삭제하도록 요청할 수 있습니다. 예를 들어 귀하의 콘텐츠 중 일부가 다른 사용자에 의해 다시 게시되었을 수 있으므로 귀하의 요청이 콘텐츠 또는 정보의 완전하거나 포괄적인 삭제를 보장하지는 않는다는 점에 유의하시기 바랍니다.",
    "key430": "회사 소개",
    "key431": '관련 법률의 목적에 따라 Gearup Portal Pte. 는 서비스를 통해 수집된 개인정보의 "데이터 컨트롤러"입니다. 당사의 우편 주소는 1 Raffles Quay #49 Singapore 048583입니다. 본 개인정보 보호정책에 대해 궁금한 점이 있으면 당사의 우편 주소 또는 이메일(privacy@playsave.com)로 문의하시기 바랍니다.',
    "key432": NaN,
    "key433": "트레이딩 플랫폼에 어떻게 로그인하나요?",
    "key434": "playsave.com 링크를 사용하여 거래 플랫폼으로 들어갑니다. 오른쪽 상단에 있는 로그인 버튼을 클릭하여 로그인하세요.",
    "key435": "이메일, 구글, 라인, 페이스북, 트위터 또는 애플 계정을 사용해 트레이딩 플랫폼에 로그인할 수 있습니다. 기본적으로 처음 로그인할 때 플랫폼 계정을 등록해야 합니다.",
    "key436": "여러 소셜 미디어 계정에 어떻게 연결하나요?",
    "key437": "각 소셜 미디어는 하나의 플랫폼 계정에만 연결할 수 있습니다. 개인 센터 -> 계정 설정으로 이동하여 다른 플랫폼 계정에 연결할 수 있습니다. 소셜 미디어 계정을 연결한 후에는 두 계정 중 하나를 사용하여 거래 플랫폼에 로그인할 수 있으며, 소셜 미디어 계정을 플랫폼 계정에 연결하는 것은 되돌릴 수 없는 과정이라는 점에 유의하시기 바랍니다. 향후에는 소셜 미디어 계정 연결을 해제할 수 없습니다.",
    "key438": "계정을 내 이메일에 어떻게 연결하나요?",
    "key439": '트레이딩 플랫폼에 로그인하고 계좌 정보로 이동합니다. 이메일을 찾아 "이메일 연결"을 클릭합니다.',
    "key440": "계정을 연결할 이메일 주소를 입력하세요. 이 이메일에 액세스할 수 있는지 확인하세요. 완료되면 '보내기'를 클릭합니다.",
    "key441": "이메일에 로그인하여 받은 편지함에서 인증 코드 이메일을 확인하세요. 받지 못한 경우 60초 후에 '보내기' 버튼을 다시 클릭하면 됩니다.",
    "key442": "인증 코드 이메일을 열고 그 안에 있는 인증 코드를 찾으세요. 거래 플랫폼으로 돌아가서 인증 코드를 입력하여 이메일 연결 프로세스를 완료하세요.",
    "key443": "현재 거래 플랫폼은 연결된 이메일의 변경을 지원하지 않습니다. 모든 이메일은 하나의 플랫폼 계정에만 연결할 수 있습니다. 문의 사항이 있으시면 고객센터 -> 고객 서비스로 이동하여 문의하시기 바랍니다.",
    "key444": "언어와 통화는 어떻게 변경하나요?",
    "key445": "사이트 탐색에서 현재 설정된 언어 통화를 찾아 클릭하고 설정을 변경할 수 있습니다.",
    "key446": "로그인 후 '개인 센터 - 환경설정'에서 언어 및 통화 설정을 변경할 수도 있습니다.",
    "key447": "거래 수수료",
    "key448": "직접 충전 서비스:",
    "key449": "직접 충전 서비스에는 결제 처리 수수료를 제외한 추가 수수료가 없습니다. 충전 금액은 게임 퍼블리셔가 설정한 가격에 따라 조정됩니다. 실제 금액은 충전 페이지를 참조하여 결제를 완료하시기 바랍니다.",
    "key450": "아이템 거래 서비스:",
    "key451": "판매자 수수료: 판매자에게 판매 가격의 12%에 해당하는 수수료가 부과됩니다. 프로모션 기간에는 수수료가 달라질 수 있으므로 실제 부과되는 수수료를 참조하세요. 구매자 수수료: 충전 수수료 0%: 충전 페이지를 확인하시기 바랍니다. 인출 수수료: 출금 페이지를 확인하시기 바랍니다. 충전 또는 출금 페이지에서 금액을 입력하면 수수료를 계산할 수 있습니다.",
    "key452": "직접 충전 시간",
    "key453": "결제에 성공하면 10분 이내에 직접 충전 서비스가 계정에 입금됩니다. 성수기나 특별 이벤트 기간에는 지연 또는 미배송이 발생할 수 있지만 24시간 이내에 자동으로 적립 또는 환불될 예정입니다. 주문에 대해 궁금한 점이 있으면 고객 서비스에 문의하세요.",
    "key454": "직접 충전 기록은 어떻게 확인하나요?",
    "key455": "개인 센터 - 구매 기록 에서 주문 상태를 확인할 수 있습니다. 주문이 성공한 것으로 표시되면 게임 계정에 로그인하여 해당 자산 증가를 확인할 수 있습니다. 게임에서 팝업이나 게임 내 이메일을 통해 알림을 보내 충전 사실을 알려줄 수도 있습니다.",
    "key456": "직접 충전 정보를 입력하면 어떻게 되나요?",
    "key457": "중요 알림: 거래 플랫폼은 사용자의 과실, 허위 또는 부정확한 정보 제공 또는 기타 사유로 인해 발생한 오류에 대해 어떠한 책임도 지지 않습니다. 주문이 완료되면 취소하거나 환불할 수 없습니다.    ",
    "key458": "참고:",
    "key459": "1. 잘못된 충전 문제를 방지하기 위해 결제 전에 게임 계정 ID, 사용자 이름, 서버를 포함한 충전 정보를 확인하시기 바랍니다.",
    "key460": "2. 서비스 제공업체의 요구 사항으로 인해 재충전 주문이 완료되면 취소하거나 환불할 수 없습니다. 새로운 충전을 시작할 수 있지만 거래 플랫폼은 잘못된 구매 문제에 대해 책임을 지지 않습니다.",
    "key461": "3. 게임 아이디를 잘못 입력하여 충전이 실패한 경우, 입력한 정보의 오류를 확인한 후 주문이 자동으로 환불됩니다. 직접 충전 서비스 주문에 문제가 있는 경우 고객 서비스에 문의하세요.",
    "key462": "직접 충전 서비스가 적립되지 않으면 어떻게 되나요?",
    "key463": "계정?",
    "key464": "직접 충전 서비스가 계정에 입금되지 않고 주문이 환불되지 않는 경우, 결제 성공 및 미배송에 대한 관련 증빙 자료를 제공하고 고객 서비스에 문의하여 도움을 받으시기 바랍니다. 플랫폼 고객 서비스에서 충전이 게임 계정에 도착하지 않았다고 확인되면 환불이 처리됩니다.",
    "key465": "KYC 신원 확인이란 무엇이며 이 절차를 완료해야 하는 이유는 무엇인가요?",
    "key466": "playsave.com의 KYC 인증은 사용자의 신원을 확인하기 위한 결제 인증입니다.",
    "key467": "KYC 확인은 결제 카드 산업 데이터 보안 표준(PCI) 및 자금 세탁 방지 관련 국제자금세탁방지기구(FATF)의 요구 사항을 기반으로 설계되었으며, 사용자 결제/출금이 지정된 규칙에 도달할 때 트리거됩니다. 핵심 목표는 사용자의 카드 보안을 보호하고 대리 충전을 통한 자금 세탁 범죄를 방지하는 것입니다.",
    "key468": "KYC 인증은 본인임을 확인할 수 있는 서류여야 하며, 신분증, 건강보험증, 운전면허증, 학생증 등 유효한 서류를 준비해 주세요.",
    "key469": "귀하의 개인 개인 정보는 절대적으로 안전하며 playsave.com은 사용자 개인 정보를 수집하거나 공개하지 않으니 안심하십시오.",
    "key470": "KYC 신원 확인을 요청받았는데, 확인 절차가 안전한가요? 그렇다면 제가 제출한 문서는 어떻게 저장되고 사용되나요?",
    "key471": "당사는 귀하의 개인 정보 제공에 대한 귀하의 신뢰를 소중하게 생각합니다. 플레이세이브닷컴은 플레이세이브닷컴 웹사이트에서 온라인으로 수집한 개인 식별 정보(예: 이름, 주소, 휴대폰 번호 또는 이메일 주소)를 마케팅 목적이 아닌 다른 비계열사 또는 조직과 공유, 공개 또는 판매하지 않으니 안심하시기 바랍니다.",
    "key472": "KYC 인증 실패의 원인은 무엇이며 어떻게 처리해야 하나요?",
    "key473": "KYC는 실명 인증 메커니즘입니다. 사용자 자산의 안전을 보장하기 위해 플레이세이브는 충전 및 출금 시 KYC 인증을 요구합니다.",
    "key474": "KYC 인증에 실패하면 그 이유는 다음과 같습니다.",
    "key475": "1. 제출하신 실명 인증 인증서는 새로 발급된 인증서이며, 인증서 정보가 해당 관리 센터에 동기화되지 않았습니다.",
    "key476": "2. 인증서 정보가 불완전하거나 자격이 없습니다.",
    "key477": "3. 인증에 실패했습니다.",
    "key478": "KYC 인증이 실패하거나 한도에 도달하면 어떻게 해야 하나요?",
    "key479": "실명 인증으로 인한 불편을 양해해 주시기 바랍니다. 다음 단계에 따라 개인정보를 제출해 주시면 수작업 검토를 통해 처리해 드리겠습니다.",
    "key480": "「도움말 센터 - 고객 서비스」를 클릭하세요",
    "key481": "피드백 분류는 KYC 인증을 선택합니다.",
    "key482": "이름, ID 번호, 인증서 유형(신분증 또는 여권)을 입력하세요",
    "key483": "신분증을 들고 있는 사진을 업로드하세요(사진 참조)",
    "key484": "아이디와 플레이세이브 정보 페이지의 사진을 업로드하세요(사진 참조, 사용자 아이디와 아바타가 잘 보여야 합니다)",
    "key485": "위의 정보는 KYC 인증 절차에 필요하며, 귀하의 개인정보는 이 보안 인증을 위해서만 사용됩니다. 플레이세이브는 귀하의 개인정보를 엄격하게 보호하기 위해 최선을 다하고 있으며, 수동 인증은 완료하는 데 영업일 기준 약 1일이 소요됩니다.",
    "key486": "은행 카드를 사용하여 충전하는 방법은 무엇인가요?",
    "key487": "신용카드를 사용해 거래 플랫폼에서 충전할 수 있습니다. 충전 채널 운영자는 각 거래에 대해 특정 관리 수수료를 부과할 수 있습니다. 충전 페이지에서 금액을 입력하면 구체적인 수수료를 확인할 수 있습니다.",
    "key488": "충전 금액은 아이템 구매에만 사용할 수 있으며 인출할 수 없습니다.",
    "key489": "은행 카드를 계정에 연결할 때 다음 정보가 올바른지 확인하세요.",
    "key490": "이름, 국가/지역, 상세 주소 등과 같은 개인 정보. 이 정보는 카드 발급사 또는 은행에 제공된 세부 정보와 일치해야 합니다.",
    "key491": "카드 번호 및 카드 인증 코드(CVC).",
    "key492": "참고:",
    "key493": "*500 USD는 1회 최대 충전 금액이며, 사용자는 하루에 10회, 한 달에 최대 50회까지 충전할 수 있습니다.",
    "key494": "*각 플레이세이브 계정당 최대 5개의 다른 은행 카드만 추가할 수 있습니다. 그러나 모든 은행 카드의 카드 소유자 이름은 동일해야 합니다.",
    "key495": "*충전 시도가 실패하면 충전 페이지에서 시스템에서 제공한 이유를 확인하세요. 문제를 해결하고 다시 시도하세요.",
    "key496": "*매일, 매주, 매월 충전할 수 있는 횟수에는 제한이 있습니다. 충전하기 전에 은행 카드의 잔액이 충분한지 확인하시기 바랍니다. 충전 시도가 실패한 경우 충전 페이지에서 이유를 확인하고 문제를 해결하세요. 실패한 충전 시도도 한도에 포함된다는 점에 유의하시기 바랍니다.",
    "key497": "*질문 사항이 있으시면 고객 서비스에 문의하여 도움을 받으세요.",
    "key498": "신용 카드 없이 충전하는 방법은 무엇인가요?",
    "key499": "거래 플랫폼은 전자지갑 결제, 은행 송금, 편의점 결제 및 기타 결제 수단을 포함한 여러 결제 수단을 지원합니다. 사용 가능한 결제 방법은 \"개인 센터\"의 \"내 지갑\" 페이지에서 확인할 수 있습니다",
    "key500": "편의점에서 결제할 때 주의해야 할 점은 무엇인가요?",
    "key501": "현재 플랫폼은 패밀리마트, 로젠 등 편의점에서 결제를 지원합니다. 충전 정보를 입력한 후 해당 편의점에서 오프라인으로 결제할 수 있습니다.",
    "key502": "주의하세요",
    "key503": "(1) 재충전을 시작했다고 해서 구매 절차에 들어간 것은 아니며, 현재 재충전 자금은 개인 잔액에만 충전되며, 재충전에 성공한 후에는 새로운 구매를 시작해야 하며, 이 과정에서 좋아하는 소품을 다른 사람이 구매할 수 있으니 주의하시기 바랍니다.",
    "key504": "(2) 국제 결제로 인해 편의점 결제 후 충전이 도착하는 데 보통 3시간 정도 소요되오니 조금만 기다려주세요. 편의점 결제가 장시간 도착하지 않으면 \"고객 서비스\"를 클릭하여 피드백을 받을 수 있습니다.",
    "key505": "각 충전의 최소 및 최대 금액은 얼마입니까?",
    "key506": "비자 또는 마스터카드로 한 번 충전할 수 있는 최소 금액은 10달러이고 최대 금액은 5,000달러입니다.",
    "key507": "충전 수수료는 얼마인가요?",
    "key508": "은행은 거래에 대해 특정 관리 수수료를 부과합니다. 자세한 내용은 개인 센터 -> 내 지갑으로 이동하여 충전 페이지를 확인하세요(로그인 필요).",
    "key509": "현재 비자 또는 마스터카드 충전 수수료는 3.5% + USD0.15입니다. 이는 대부분의 국가에 적용됩니다. (아르헨티나, 브라질, 콜롬비아, 나이지리아, 싱가포르의 은행 카드는 현재 지원되지 않습니다. 러시아 당사자와 관련된 거래도 알 수 없는 이유로 실패할 수 있습니다.",
    "key510": "충전 오류 및 해결 방법",
    "key511": "충전 요청이 실패하면 충전 오류의 원인을 주의 깊게 확인해 주세요. 다양한 오류에 대한 해결 방법은 다음과 같습니다.",
    "key512": "(1) 단일 충전 한도 초과 충전 주문에 '승인 안 함' 또는 '사기 의심'과 같은 오류 메시지가 표시되면 충전 한도가 초과되어 보안 경고가 트리거된 것일 수 있습니다. 1회 충전 금액을 미화 100달러 미만으로 유지하고 다시 시도하세요.",
    "key513": "(2) 결제 당사자가 거래를 거부할 수 있는 기타 이유 충전 요청이 실패할 경우, 거래 플랫폼이 아닌 결제 당사자가 거래를 거부했기 때문일 가능성이 높습니다. 몇 가지 가능한 이유는 다음과 같습니다.",
    "key514": "은행 계좌에 잔액이 부족합니다",
    "key515": "은행 카드가 제한되었습니다",
    "key516": "결제 당사자가 거래를 거부할 수 있는 사유에 대한 자세한 내용은 결제 당사자에게 직접 문의하시기 바랍니다.",
    "key517": "거래 플랫폼은 다음과 같은 경우 충전 요청을 거부할 수도 있습니다.",
    "key518": "두 개 이상의 서로 다른 거래 플랫폼 계정을 동일한 신용카드에 연결하려고 했습니다",
    "key519": "충전 한도에 도달했습니다. 거래 플랫폼은 실패한 충전 거래에 대해 수수료를 징수하지 않습니다. 다음 방법을 사용하여 다시 충전할 수 있습니다.",
    "key520": "연결된 은행 카드 변경",
    "key521": "다른 브라우저나 PC를 사용하세요",
    "key522": "적은 금액으로 여러 번 충전하기",
    "key523": "브라우저의 차단된 팝업 알림 활성화",
    "key524": "충전 거래와 관련하여 궁금한 점이 있으면 '고객 서비스'를 클릭하여 문의할 수 있습니다.",
    "key525": "은행 카드로 인출하는 방법은 무엇인가요?",
    "key526": "출금 페이지에서 은행 계좌로 출금하도록 선택할 수 있습니다. 대부분의 경우 출금 요청은 1일 이내에 검토 및 승인되며 영업일 기준 1~5일 이내에 계좌에 금액이 입금됩니다. 구체적인 소요 시간은 은행에 따라 다릅니다.",
    "key527": "출금이 실패한 경우 출금 페이지에서 이유를 확인하시기 바랍니다. 가능한 경우 문제를 해결하고 다시 시도하세요.    ",
    "key528": "또한 일본의 엄격한 규정으로 인해 일본 지역의 사용자는 탈퇴 양식에 다음을 기입해야 합니다:    ",
    "key529": "결제 채널에서 요구하는 대로 '이름'과 '성'을 영어로 입력하세요.",
    "key530": '도시, 거리, 집 번호를 포함한 상세 주소를 입력하세요. 다음 형식으로 주소를 입력하는 것이 좋습니다: "XXX번지, XXX로, XXX번지". 주소에 숫자만 포함된 경우에는 대신 다음 형식으로 주소를 입력하세요: 주문이 거부되는 것을 방지하려면 "XXX 타운 1-2-1203"과 같은 형식으로 입력하세요.',
    "key531": "현지 출금을 선택한 경우 계좌 이름은 가타카나 또는 영문이어야 합니다. 스위프트 송금을 선택한 경우 계좌 이름은 영문이어야 합니다.",
    "key532": "계정 이름은 이름과 성이 같아야 하며, 둘 다 카드 소유자의 실명이어야 합니다. 언어 우선순위는 다음과 같습니다: 영어 > 가타카나.",
    "key533": '출금 요청을 제출하면 플랫폼 또는 채널에서 요청을 검토합니다. 출금 요청 상태가 "승인됨"으로 변경되면 영업일 기준 1~5일 이내에 계좌에 자금이 입금됩니다.',
    "key534": "충전 잔액은 인출할 수 없습니다. 아이템 판매로 발생한 수익만 출금할 수 있습니다. 최대 인출 금액은 한 번에 2,000달러이며, 모든 거래에 대해 수동 승인이 필요합니다. 사용자는 하루에 5회 출금할 수 있으며, 연간 총 출금 금액은 20,000 USD를 초과할 수 없습니다.",
    "key535": "또한 기프트 카드, 모바일 충전 카드와 같은 더 많은 인출 옵션을 모색하고 있습니다. 더 많은 업데이트를 기대해주세요.",
    "key536": "Payoneer 계정으로 출금하려면 어떻게 해야 하나요?",
    "key537": "Payoneer는 전 세계 사용자에게 서비스를 제공하는 국제 결제 플랫폼입니다. 대부분의 은행 송금 및 타사 결제 수단을 지원합니다.",
    "key538": "은행카드를 사용하여 Payoneer 계정을 만들 수 있습니다. 그런 다음 거래 플랫폼 계정에서 Payoneer 계정으로 출금한 후 Payoneer 계정에서 은행 카드로 자금을 이체하세요. 단, 특정 수수료가 부과됩니다.",
    "key539": "Payoneer 계정으로 출금하려면 다음 단계를 따르세요.",
    "key540": "페이오니아 계정을 설정합니다.",
    "key541": "Payoneer의 지침에 따라 본인 인증 절차를 완료하세요. 은행 카드 또는 타사 결제 수단을 Payoneer 계정에 연결하세요.",
    "key542": "거래 플랫폼의 출금 페이지로 이동하여 플랫폼 계정을 Payoneer 계정에 연결하세요(로그인 필요).",
    "key543": "출금 요청을 제출하고 Payoneer 계정에 자금이 입금될 때까지 기다리세요.",
    "key544": "스위프트와 로컬의 차이점은 무엇인가요?",
    "key545": '"Swift"의 송금 방식은 "Local"의 송금 방식과 다릅니다. 스위프트는 국제 전신 송금으로 비용이 비싸고 도착 시간이 느립니다. Local은 현지 송금으로 비용이 저렴하고 도착이 빠릅니다. 먼저 로컬 모드로 송금하는 것이 좋습니다.',
    "key546": "출금을 수행할 수 없는 이유는 무엇인가요?",
    "key547": "거래 플랫폼에서의 모든 출금은 플랫폼과 관련 은행에서 검토합니다. 출금 요청이 거부될 수 있는 사유는 다음과 같습니다.",
    "key548": "플랫폼에 입력한 은행 정보가 은행에 등록된 정보와 일치하지 않습니다",
    "key549": "귀하의 계정이 현재 제한되고 있습니다",
    "key550": "출금에 대해 궁금한 점이 있으면 고객센터-> 고객 서비스로 이동하여 문의하세요.",
    "key551": "최소 인출 금액은 얼마입니까?",
    "key552": "은행 송금: USD50",
    "key553": "전자지갑: USD50",
    "key554": "내 계정에 금액이 입금되기까지 얼마나 걸리나요?",
    "key555": "은행 송금: 영업일 기준 1-5일",
    "key556": "Payoneer: 영업일 기준 1일",
    "key557": "출금 수수료는 얼마인가요?",
    "key558": "다른 결제 채널에 대한 수수료:",
    "key559": "Payoneer: 1% + $1(최소 $2); 실제 수수료는 거래 금액에 따라 다릅니다.",
    "key560": "은행 카드: 1% + 고정 수수료(수취 은행에 따라 2.5-8달러). 일반적으로 현지 거래에는 2.5달러가 부과되며, Swift 송금에는 8달러가 부과됩니다. 인출 또는 충전 요청 시 현지 송금을 지원하는 은행 카드를 사용하는 것이 좋습니다).",
    "key561": "*출금 요청에 환전이 필요한 경우 은행에서 실시간 환율을 사용할 수 있으며 추가 수수료가 적용될 수 있습니다.",
    "key562": "*수취 은행은 은행 수수료 또는 기타 수수료와 같은 추가 수수료를 부과할 수 있습니다. 자세한 내용은 은행에 문의하세요.",
    "key563": "*거래 플랫폼은 출금 요청 실패에 대한 수수료를 징수하지 않습니다. 발생한 수수료는 결제 채널 또는 은행에서 청구합니다.",
    "key564": "출금 요청이 지원되는 국가/지역은 어디인가요?",
    "key565": "현재 플랫폼이 은행 송금을 지원하는 국가 및 지역(알파벳순):",
    "key566": "아르헨티나, 호주, 오스트리아, 벨기에, 보스니아 헤르체고비나, 브라질, 불가리아, 캄보디아, 캐나다, 칠레, 콜롬비아, 코스타리카, 크로아티아, 키프로스, 체코 공화국, 덴마크, 이집트, 에스토니아, 핀란드, 프랑스, 조지아, 독일, 그리스, 과테말라, 헝가리, 아이슬란드, 인도, 인도네시아, 아일랜드, 이스라엘, 이탈리아 , 일본, 카자흐스탄, 라트비아, 리투아니아, 룩셈부르크, 말레이시아, 몰타, 멕시코, 몰도바, 모로코, 네덜란드, 뉴질랜드, 북마케도니아, 노르웨이, 파키스탄, 파나마, 페루, 필리핀, 폴란드, 포르투갈, 루마니아, 러시아, 세르비아, 싱가포르, 슬로바키아, 대한민국, 스페인, 스웨덴, 스위스, 태국, 터키, 우크라이나, UAE, 영국, 미국, 우루과이, 베트남.",
    "key567": "플랫폼이 현재 Payoneer 인출을 지원하는 국가 및 지역:",
    "key568": "일반적으로 전 세계, 실제 상황에 따라 변경 될 수 있습니다.",
    "key569": "7일",
    "key570": "마지막 수정 [2024.01.01]",
    "key571": "발효일 [2024.01.01]",
    "key572": "쿠키 및 유사 기술 정책",
    "key573": '[playsave]("당사" 또는 "당사")는 [https://playsave.com]("사이트")에서 쿠키 및 기타 유사한 기술을 사용합니다. 본 쿠키 및 유사 기술 정책("CST 정책")은 당사의 개인정보 처리방침을 보완하며 당사가 사이트와 관련하여 쿠키 및 유사 기술을 사용하는 방법을 설명합니다.',
    "key574": "질문이 있으시면 [support@playsave.com] 이메일로 문의해 주세요.",
    "key575": "쿠키 및 유사 기술이란 무엇인가요?",
    "key576": "쿠키 는 사용자의 기기에 저장되어 특정 기능을 제공할 수 있도록 하는 작은 파일입니다. 쿠키는 사이트 방문에 관한 소량의 데이터를 컴퓨터에 저장할 수 있도록 하는 웹사이트의 표준 기능입니다. 쿠키는 사이트의 어떤 영역이 유용하고 어떤 영역이 개선이 필요한지 파악하는 데 도움이 됩니다.",
    "key577": "회원님 은 브라우저의 설정을 변경하거나 사이트의 특정 설정을 변경하여 쿠키 및 유사 기술의 사용을 일반적으로 허용할지 여부를 선택할 수 있습니다(본 CST 정책의 섹션 3에 명시된 대로). 그러나 쿠키 및 유사 기술을 비활성화하면 사이트 이용 경험이 저하되고 일부 기능이 의도한 대로 작동하지 않을 수 있습니다.    ",
    "key578": "어떤 쿠키와 유사한 기술을 사용하나요?",
    "key579": '아래에는 당사가 사이트를 운영하기 위해 사용하는 다양한 유형의 쿠키 및 유사한 기술이 나열되어 있습니다. 쿠키는 당사가 직접 귀하의 기기에 제공하거나(자사 쿠키), 당사를 대신하여 제3자가 제공(제3자 쿠키)할 수 있습니다. 쿠키는 일시적이며 브라우저를 닫으면 만료되거나("세션" 쿠키), 영구적이며 브라우저를 닫은 후에도 기기에 남아 있을 수 있습니다("영구" 쿠키).',
    "key580": "필수 쿠키",
    "key581": "필수 쿠키는 사이트 운영에 필수적입니다. 당사는 사이트를 표시하고 네트워크를 관리하거나 관련 법률을 준수하기 위해 이러한 쿠키를 사용합니다. 사이트를 사용할 때 항상 다음 쿠키가 설정됩니다.",
    "key582": "쿠키 이름",
    "key583": "목적에 대한 설명",
    "key584": "영구 쿠키 또는 세션 쿠키? 영구 쿠키는 언제 만료되나요?",
    "key585": "제1자(방문 중인 사이트에서 설정) 또는 제3자(여러 사이트에 걸쳐)?",
    "key586": "accept_essential",
    "key587": "이 쿠키는 사용자가 필요한 쿠키를 수락했는지 여부를 기록하는 데 사용됩니다.",
    "key588": "영구",
    "key589": "첫 번째 파티",
    "key590": "accept_analytical",
    "key591": "이 쿠키는 사용자가 분석 쿠키를 수락했는지 여부를 추적하는 데 사용됩니다.",
    "key592": "ps-token",
    "key593": "당사는 이 쿠키를 사용하여 귀하의 계정을 확인하고 로그인 시점을 확인하여 귀하가 당사 웹사이트에 더 쉽게 액세스하고 적절한 경험과 기능을 표시할 수 있도록 합니다.",
    "key594": "설치-쿠폰-청구됨",
    "key595": "이 쿠키는 사용자가 PWA 쿠폰을 청구했는지 여부를 기록하는 데 사용됩니다.",
    "key596": "더 이상 프롬프트 없음",
    "key597": "이 쿠키는 다시 프롬프트할 필요가 없는 정보를 이해하기 위해 사용자 확인을 기록하는 데 사용됩니다.",
    "key598": "장치_ID(로컬 저장소)",
    "key599": "이 쿠키는 알림 전송을 위한 디바이스 ID를 기록하는 데 사용됩니다.",
    "key600": "기본 설정 쿠키. 기본 설정 쿠키는 사용자의 선택 및 기본 설정에 대한 정보를 수집하고 언어 또는 기타 지역 설정을 기억하고 그에 따라 사이트를 맞춤 설정할 수 있도록 합니다.",
    "key601": "목적에 대한 설명",
    "key602": "쿠키는 영구 쿠키인가요, 세션 쿠키인가요? 영구 쿠키는 언제 만료되나요?",
    "key603": "제1자(방문 중인 사이트에서 설정) 또는 제3자(여러 사이트에 걸쳐)? 제3자 표시(쿠키 정책에 대한 전체 법적 이름 및 URL)",
    "key604": "로그인 숨기기",
    "key605": "이 쿠키는 로그인 상자를 숨길지 여부를 기록하는 데 사용됩니다.",
    "key606": "1일",
    "key607": "stay_login",
    "key608": "이 쿠키는 \"로그인 유지\" 옵션이 선택되어 있는지 여부를 기록하는 데 사용됩니다.",
    "key609": "로그인 채널",
    "key610": "이 쿠키는 로그인 방법을 기록하는 데 사용됩니다...",
    "key611": "레이아웃 접힘",
    "key612": "이 쿠키는 사용자가 왼쪽 메뉴를 접었는지 여부를 기록하는 데 사용됩니다.",
    "key613": "인벤토리-나이프아웃-토스트",
    "key614": "이 쿠키는 홈페이지에 상시 프롬프트가 표시되었는지 여부를 기록하는 데 사용됩니다.",
    "key615": "선택 언어",
    "key616": "이 쿠키는 사용자가 선택한 기본 언어를 기록하는 데 사용됩니다.",
    "key617": "선택 통화",
    "key618": "이 쿠키는 사용자가 선택한 기본 통화를 기록하는 데 사용됩니다.",
    "key619": "announcement-id",
    "key620": "이 쿠키는 사용자가 공지사항을 닫았는지 여부를 기록하는 데 사용됩니다.",
    "key621": "재충전-폴링",
    "key622": "이 쿠키는 진행 중인 충전 주문 ID를 기록하고 주문 상태 표시를 업데이트하는 데 사용됩니다.",
    "key623": "체크아웃 카드 알림",
    "key624": "이 쿠키는 카드를 처음 바인딩하는 동안 프롬프트가 표시되었는지 여부를 기록하는 데 사용됩니다.",
    "key625": "체크아웃 소스 폴링",
    "key626": "이 쿠키는 진행 중인 카드 바인딩 ID의 보류 중인 쿼리를 기록하고 카드 바인딩 상태 표시를 업데이트하는 데 사용됩니다.",
    "key627": "철회-폴링",
    "key628": "이 쿠키는 진행 중인 출금 주문의 ID를 기록하고 주문 상태 표시를 업데이트하는 데 사용됩니다.",
    "key629": "TOPUPFROM",
    "key630": "이 쿠키는 충전 중에 사용자가 작성한 양식 내용을 기록하여 후속 구매를 위한 자동 채우기를 용이하게 하는 데 사용됩니다.",
    "key631": "TOPUPTIP",
    "key632": "이 쿠키는 사용자가 충전 페이지 프롬프트를 닫았는지 여부를 기록하는 데 사용됩니다.",
    "key633": "성능/분석 쿠키. 성능 쿠키(분석 쿠키 포함)는 방문 및 트래픽 소스를 집계하고, 가장 인기 있는 페이지와 가장 인기 없는 페이지를 표시하며, 방문자가 사이트를 이동하는 방식을 추적하는 등 사이트 운영 방식, 방문자가 누구인지, 사이트를 어떻게 사용하는지 이해하는 데 도움이 됩니다. 여기에는 귀하가 본 페이지, 참조 및 종료 페이지, 방문 날짜, 시간 및 기간 등 귀하가 당사 사이트와 상호 작용하는 방식에 대한 정보가 포함됩니다. 또한 귀하의 도시 또는 국가와 같은 일반적인 위치 정보(귀하의 IP 주소에서 유추)를 수집할 수도 있습니다.",
    "key634": '특히, 당사는 Google, Inc.("Google")에서 제공하는 웹 분석 서비스인 Google 애널리틱스를 사용합니다. Google은 쿠키를 사용하여 사용자 행동(예: 클릭 이벤트, 페이지 조회수 및 위치 정보)을 추적하여 사용자가 당사 사이트를 어떻게 사용하는지 파악하고 분석합니다. 쿠키에 의해 생성된 귀하의 사이트 사용에 관한 정보(귀하의 IP 주소 포함)는 미국 내 서버에 있는 Google로 전송되어 저장됩니다. Google 애널리틱스 쿠키에 대한 자세한 내용은 Google의 도움말 페이지 및 개인정보처리방침을 참조하시기 바랍니다.',
    "key635": "쿠키 및 유사한 기술을 어떻게 관리하나요?",
    "key636": "귀하는 당사의 쿠키 기본 설정 센터를 통해 언제든지 동의를 철회하는 등 퍼스트 파티 쿠키에 대한 설정을 변경할 수 있습니다:",
    "key637": "여기에서 제공되는 Google의 브라우저 플러그인을 다운로드하여 설치하면 Google 애널리틱스의 정보 수집 및 사용을 방지할 수 있습니다. ",
    "key638": "브라우저에서 모든 쿠키를 삭제하거나 특정 사이트의 쿠키만 허용하거나 쿠키가 전송되는 시기를 표시하도록 허용할 수 있습니다. 자주 사용하는 브라우저에서 쿠키를 관리하는 방법에 대한 지침은 다음에서 확인할 수 있습니다: 인터넷 익스플로러, 파이어폭스, 크롬, 사파리(iOS), 사파리(Mac), 오페라. 필요한 쿠키를 비활성화하지 않으면 사이트가 제대로 작동하지 않을 수 있으므로 쿠키를 비활성화할 수 없습니다. 설정된 쿠키를 확인하는 방법을 비롯하여 쿠키에 대해 자세히 알아보려면 www.aboutcookies.org 또는 www.allaboutcookies.org 을 방문하세요. 쿠키를 비활성화하면 사이트의 모든 기능이 의도한 대로 작동하지 않을 수 있습니다.",
    "key639": "추적하지 않음",
    "key640": '"추적 금지"("DNT")는 사용자가 특정 웹 브라우저에서 설정할 수 있는 개인정보 기본 설정입니다. DNT는 사용자가 웹사이트 또는 온라인 서비스에서 웹페이지 방문에 대한 특정 정보를 시간이 지남에 따라 수집하는 것을 원하지 않는다고 웹사이트에 알릴 수 있는 방법입니다. 여기에서 추적 금지에 대해 자세히 알아볼 수 있습니다. 웹 브라우저마다 이 기능을 통합하고 활성화하는 방식에 차이가 있기 때문에 현재 이러한 신호에 대한 대응 조치를 취하지 않습니다.',
    "key641": "이 쿠키 정책의 변경",
    "key642": "이 CST 정책은 변경될 수 있습니다. 이 CST 정책을 정기적으로 검토하여 개정 또는 수정 사항이 있는지 확인하는 것이 좋습니다.",
    "key643": "아바타 변경",
    "key644": "제휴 프로그램 신청",
    "key645": "트래픽 제휴 계약",
    "key646": "소개",
    "key647": '본 트래픽 제휴 계약은 리워드 일정을 포함하되 이에 국한되지 않는 모든 해당 일정과 함께 귀하(이하 "파트너")가 현재 GEARUP PORTAL PTE가 소유 및 운영하는 https://www.playsave.com("플랫폼")을 이용하기 위해 체결하는 계약(이하 총칭하여 "계약")입니다. LTD. ("플레이세이브"). 본 계약은 플랫폼에서 제공하는 트래픽 제휴 프로그램과 관련하여 플레이세이브와 파트너 간의 조건을 명시합니다. 본 계약은 동일한 주제에 대해 플레이세이브와 파트너 간에 체결된 서면 계약에 의해 전체 또는 일부가 대체되지 않는 한 파트너에게 적용됩니다.',
    "key648": "광고 캠페인 기회",
    "key649": '트래픽 제휴 프로그램에 따라 플레이세이브의 역할은 주로 파트너를 위한 광고 캠페인 기회(각각 "캠페인")를 제안 및 설정하고 파트너를 해당 캠페인에 참여하도록 초대하는 것입니다. 해당 보상 일정(이하 정의)을 포함한 각 신규 캠페인의 세부 사항은 플랫폼 웹사이트에 명시됩니다. 의심의 여지를 없애기 위해 플레이세이브는 어떠한 기회나 캠페인도 보장하지 않으며, 각 기회는 비독점적으로 파트너와 공유됩니다.',
    "key650": "프로모션 및 지급액 추적",
    "key651": '파트너 는 플랫폼으로 트래픽을 성공적으로 유도하거나 사용자가 플랫폼의 상품 및 서비스를 구매하도록 추천한 것에 대해 보상을 받게 됩니다. 해당 보상 체계는 [웹사이트]에서 확인할 수 있는 본 계약의 일정("보상 일정")에 명시되어 있습니다. 보상 일정에는 파트너가 보상 일정에 명시된 특정 플랫폼 가상 크레딧("지급금")을 획득할 수 있는 행위("행위") 및 적격 매개변수("조건")가 명시되어 있습니다. 지급금은 플랫폼의 단독 재량에 따라 행위가 완료되고 조건이 충족되었다는 플랫폼의 승인에 따라 결정됩니다. 보상 일정은 플랫폼의 사업적 필요에 따라 플랫폼의 단독 재량에 따라 수시로 업데이트될 수 있습니다. 활동 추적 및 지급금 계산과 관련된 모든 추적 및 지급 처리 기능은 플레이세이브가 제공하고 수행합니다. 플레이세이브가 서면으로 명시적으로 승인하거나 보상 일정에 달리 명시하지 않는 한, 파트너는 다음과 같은 수단을 사용하여 캠페인을 홍보하기 위해 자료를 사용할 수 없습니다: (a) 의도된 소비자("최종 사용자") 행동을 통해 얻은 리드 제공(예. 전화번호부 또는 이와 유사한 개인 데이터 수집을 통해), (b) 가짜 리디렉션, 자동화된 소프트웨어 또는 기타 메커니즘을 사용하여 행위를 생성하는 행위, (c) 자동화된 장치, 로봇, 아이프레임 또는 숨겨진 프레임을 사용하는 행위와 같이 선의가 아닌 행위; (d) 최종 사용자로부터 액션을 얻기 위해 인센티브를 사용하거나 (e) 유사한 플랫폼 및 게임에서 구매/거래 행위가 진실하지 않거나 불성실한 사용자(예: 높은 지불 거절 또는 기타 비정상적인 행동의 기록이 있는 것으로 알려진 사용자)를 추천하는 행위.',
    "key652": "지적 재산권 및 기밀 유지",
    "key653": '라이선스: 본 약관에 따라 플레이세이브는 각 캠페인 기간 동안 파트너에게 본 약관의 의무를 수행하는 데 필요한 범위 내에서만 플레이세이브가 제공하는 모든 자료("자료")를 사용할 수 있는 취소 가능하고 비독점적이며 양도 불가능한 전 세계 로열티 없는 사용권을 부여합니다.',
    "key654": '지적 재산: "지적 재산"이란 상표(등록 또는 미등록 여부 및 이와 관련된 모든 영업권과 함께), 미등록 및 등록 디자인, 저작권, 데이터베이스 권리, 컴퓨터 소프트웨어에 대한 권리, 도메인 이름, 기밀 정보에 대한 권리(이하 정의) 및 기타 모든 지적 재산권(현재 존재하거나 향후 생성될 수 있는 권리 포함)을 의미합니다. 파트너가 본 계약을 수락한 개시일 이전에 존재하는 모든 지적 재산권은 해당 날짜 직전에 그러한 권리를 소유한 당사자에게 귀속됩니다. 플레이세이브는 플랫폼 웹사이트 및 플랫폼, 자료 및 해당 보상 일정을 포함한 모든 캠페인에 존재하는 지적 재산에 대한 모든 권리, 이익 및 소유권을 소유하며, 파트너는 플레이세이브의 지적 재산에 대한 어떠한 소유권도 취득하거나 주장하지 않는다는 것을 인정하고 동의합니다." 라고 명시되어 있습니다',
    "key655_1":"기밀 정보: ",
    "key655": '기밀 정 는 영업 비밀, 재무 및 기술 정보, 고객, 가격, 할인 및 마진과 같은 유형 또는 무형의 모든 기밀 정보 및 데이터를 의미합니다. 플레이세이브 및/또는 다른 파트너(이하 "공개 당사자")로부터 기밀 정보를 수신하는 파트너(이하 "수신 당사자")는 (a) 모든 기밀 정보를 기밀로 유지하고 수신 당사자가 자신의 기밀 정보를 보호하는 것과 동일한 수준의 주의로 이를 보호하며 (b) 본 계약의 목적과 본 계약에서 허용하는 용도로만 그러한 기밀 정보를 사용한다는 데 동의합니다; (c) 본 계약의 목적을 제외하고 그러한 기밀 정보를 복사하거나 복제하지 않을 것; (d) 본 계약의 목적을 위해 그러한 기밀 정보를 알아야 할 필요가 있고 이를 보호하기 위해 서면으로 구속력이 있는 직원 및 대리인에게만 그러한 기밀 정보의 공개를 제한할 것. 전술한 의무는 기밀로 지정된 정보가 공개되기 전에 해당 기밀 정보가 다음과 같은 경우에는 적용되지 않습니다: 기밀 유지 의무 없이 수신 당사자에게 이미 알려진 경우, 수신 당사자의 부당한 행위 없이 공개적으로 알려졌거나 알려지게 된 경우, 수신 당사자가 공개 당사자의 기밀 정보와 무관하게 독자적으로 개발한 경우, 기밀 유지에 대한 제한 없이 제3자로부터 받은 경우, 기밀 유지 의무 없이 공개 당사자가 제3자에게 공개한 경우 또는 공개 당사자의 사전 서면 승인에 의해 공개가 승인된 경우. 수신 당사자가 법원 명령, 정부 기관의 요청 또는 기타 법적 절차에 따라 공개 당사자의 기밀 정보를 공개하라는 요청을 받는 경우, 수신 당사자는 즉시 공개 당사자에게 통지하고 공개 당사자가 공개해야 하는 기밀 정보의 일부를 법원이 명령을 내린 목적 또는 기타 법률에서 요구하는 목적으로만 사용하도록 요구하는 보호 명령을 받는 데 합리적으로 협조해야 합니다. 각 파트너는 이와 관련된 법적 비용을 자체적으로 부담해야 합니다.',
    "key656": "진술, 면책 조항 및 면책",
    "key657": "진술 및 보증: (a) 각 파트너는 다음을 보증, 진술 및 약속합니다: (i) 본 계약에 따른 의무를 이행할 수 있는 모든 권한과 권한을 보유하고 있으며, (ii) 본 계약에 따른 의무의 체결 및 이행이 제3자의 권리를 침해하거나 제3자에 대한 의무를 위반하지 않으며, (iii) 본 계약에 따른 의무를 이행함에 있어 모든 관련 법률, 규칙 및 규정을 완전히 준수합니다.",
    "key658": " 면책: 각 파트너('피면책자')는 플레이세이브 및 기타 파트너와 해당 주주, 이사, 임원, 직원, 하청업체 및 대리인(총칭하여 '피면책자')을 피면책자의 본 계약 위반으로 인해 제3자가 발생, 청구 또는 유지한 모든 청구, 소송, 비용, 손해배상 책임, 경비(합리적인 변호사 비용 포함), 합의 및 판결('청구')로부터 방어, 면책 및 보호해야 하며, 다만 다음과 같은 경우에 한하여 면책자에게 해를 입히지 않도록 합니다: (a) 피면책자가 클레임 통지를 받은 후 상업적으로 합리적인 시간 내에 피보험자에게 서면으로 통지하고, (b) 피보험자가 방어 및 모든 관련 합의 협상을 단독으로 통제하며(단, 피보험자의 합리적인 동의 없이 피면책자의 과실을 인정하는 방식으로 클레임을 합의할 수 없음), (c) 피면책자가 본 조항에 따른 의무 이행에 필요한 합리적인 지원, 정보 및 권한을 피보험자에게 제공한다는 조건입니다. 피면책자는 피면책자의 비용으로 청구의 방어에 참여할 수 있으며, 그러한 참여는 본 섹션에 따른 피면책자의 의무를 포기하거나 감경하지 않습니다.",
    "key659": '책임의 제한: (a) 아래의 어떠한 내용도 법률에 따라 책임을 배제하거나 제한할 수 없는 책임(총칭하여 "제외된 손실")을 배제하거나 제한하는 데 작용하지 않습니다. (b) 제외된 손실과 관련하여, 본 계약 및 각 보상 일정으로 인하여 또는 이와 관련하여 발생하는 계약, 불법행위(과실 또는 법적 의무 위반, 허위 진술 또는 기타 포함) 또는 기타 일반법 또는 법적 소송 원인에 대한 각 당사자의 다른 당사자에 대한 책임은 보상 일정에 따라 플레이세이브가 실제로 지급한 지급금 및/또는 기타 수수료로 제한됩니다. (c) 제외된 손실을 제외하고, 어느 당사자도 계약, 불법행위(과실 포함) 또는 기타 방식으로 상대방에 대해 실제 또는 잠재적 이익, 계약 또는 고객의 손실, 데이터 및 착수 데이터 또는 기타 복원의 손실, 평판의 손실, 기타 간접, 결과적, 특별, 징벌적, 예시적 손해에 대해 과실, 계약 위반 또는 기타로 인해 발생하는 모든 책임을 부담하지 않습니다.',
    "key660": "일반",
    "key661": "구제책의 포기: 플레이세이브가 본 계약의 조항을 행사하거나 집행하는 데 있어 관용이나 지연이 플레이세이브의 권리를 침해하거나 제한하지 않으며, 권리 포기가 후속 위반에 대한 포기로 작용하지 않습니다. 본 계약에서 양 당사자에게 부여되거나 유보되거나 법률에 의해 이용 가능한 권리, 권한 또는 구제책은 해당 파트너가 이용할 수 있는 다른 권리, 권한 또는 구제책을 배제하지 않으며 그러한 각 권리, 권한 또는 구제책은 누적적으로 적용됩니다.",
    "key662": "Assignment: 파트너는 본 계약에 따른 권리와 의무의 일부 또는 전부를 제3자에게 양도하거나 재계약할 수 없습니다.",
    "key663": "통지: 본 계약에 따라 제공해야 하는 모든 통지는 서면으로 이루어져야 합니다(이메일 또는 기타 전자적 수단으로 충분합니다).",
    "key664": " 전체 계약: 본 계약은 본 계약의 주제와 관련된 전체 이해를 나타내며 전체 계약을 구성하고, 본 계약의 주제에 관한 이전 계약을 대체하며, 양 당사자가 서면으로만 수정하고 실행할 수 있습니다. 각 당사자는 본 계약에 명시적으로 명시된 것 이외의 어떠한 진술이나 보증에 의존하지 않았음을 인정하고 이에 동의합니다.",
    "key665": "전자 서명: 각 당사자는 본 계약의 클릭 수락을 통해 공인 전자 서명을 제출하고 법적 구속력이 있는 계약을 체결한다는 사실을 인정하고 이에 동의합니다. 또한 각 당사자는 원본 서명이나 비전자 기록의 전달 또는 보존을 요구하는 관할권의 모든 관련 법령, 규정, 규칙, 조례 또는 기타 법률에 따른 권리 또는 요구 사항, 또는 전자적 수단이 아닌 다른 방법으로 지급 또는 크레딧 부여를 포기합니다.",
    "key666": "분리 가능성: 본 계약의 전체 또는 일부 조항이 관할 법원 또는 행정 기관에 의해 법률 제정 또는 규칙에 따라 불법, 무효 또는 집행 불가능하다고 판단되는 경우 해당 조항 또는 일부는 본 계약의 일부를 구성하지 않는 것으로 간주되며 본 계약의 나머지 조항의 집행 가능성 및 유효성에는 영향을 미치지 않습니다. 본 계약의 유효성 및 집행 가능성은 본 계약의 나머지 부분에 영향을 미치지 않습니다. 양 당사자는 당사자의 명시된 의도를 이행하기 위해 무효화된 조항 또는 부분을 수정하기 위해 성실히 노력해야 합니다.",
    "key667": "존속: 본 계약의 본질상 본 계약의 종료 또는 만료 후에도 존속하는 것으로 합리적으로 해석되어야 하는 모든 조항은 본 계약의 종료 또는 만료 후에도 존속합니다.",
    "key668": "당사자의 관계: 파트너의 관계는 독립 계약자의 관계이며 본 계약은 그들 사이에 어떠한 협회, 파트너십, 합작 투자 또는 대리인 관계를 형성하지 않습니다. 어느 파트너도 어떤 방식으로든 상대방을 구속하거나 상대방에 대한 책임을 발생시킬 권한을 갖지 않습니다.",
    "key669": "계약에 동의하고 활성화",
    "key670": "비밀번호 변경",
    "key671": "내 프로모션 링크",
    "key672": "기본 링크",
    "key673": "링크 복사",
    "key674": "내 프로모션 수입",
    "key675": "정산 금액",
    "key676": "누적 금액",
    "key677": "보류 중인 결제 금액",
    "key678": "수입 세부 정보",
    "key679": "사용자 세부 정보",
    "key680": "철회",
    "key681": "로그아웃",
    "key682": "아직 수입 기록이 없습니다",
    "key683": "아직 계정이 없으신가요?",
    "key684": "계정이 있나요?",
    "key685": "계정을 등록하거나 로그인하면 약관에 동의하는 것입니다.",
    "key686": "로그인하여 전체 서비스를 즐기세요!",
    "key687": "전체 confrimPassword 입력",
    "key688": "두 번 입력한 비밀번호가 일치하지 않습니다!",
    "key689": "이메일을 입력하세요",
    "key690": "잘못된 이메일",
    "key691": "코드를 입력하세요",
    "key692": "전체 비밀번호 입력",
    "key693":"인증 코드",
    "key694":"인증 코드가 이메일로 전송되었으며 10분 동안 유효합니다.",
    "key695":"새 비밀번호",
    "key696":"거래 메시지, 계정 보안 등과 같은 중요한 정보를 받으려면 이몰을 바인딩하세요.",
    "key697":"연결",
    "key698":"playsave.com의 더 많은 서비스에 액세스하려면 Google 계정을 바인딩하세요.",
}
